import { isTunnelPurchaseFlow } from "../../common/utils/util";

export const SPAIN = 'ES';
export const COLOMBIA = 'CO';
export const MEXICO = 'MX';

/*----- DECLARE INTERFACES ------*/
export declare interface TaxRegime {
  id: number;
  description: string;
  country: string;
}

export declare interface CFDI {
  id: string;
  description: string;
}

export declare interface Region {
  id: number;
  description: string;
}

export declare interface PersonType {
  id: number;
  description: string;
}

export declare interface DocumentType {
  id: number;
  description: string;
}

export declare interface City {
  id: string;
  name: string;
  regionId: number;
  country: string;
}

export declare interface Representacion {
  id: string;
  name: string;
  description: string;
}

export declare interface IdentificationType {
  id: number;
  description: string;
}

export declare interface TaxInfoDetails {
  taxId?: string;
  name?: string;
  postalCode?: string;
  selectedCfdi?: CFDI | undefined;
  selectedPersonType?: PersonType | undefined;
  selectedDocumentType?: DocumentType | undefined;
  selectedRegion?: Region | undefined;
  selectedCity?: City | undefined;
  selectedRepresentation?: Representacion | undefined;
  selectedTaxRegime?: TaxRegime | undefined;
  selectedIdentificationType?: IdentificationType | undefined;
}

/*----- Options Loaders ------*/

export const getTaxRegimeOptions = (country: string) => {
  const taxRegimeOptions: TaxRegime[] = [];

  switch (country) {
      case 'MX':
          taxRegimeOptions.push(
              { id: 622, description:'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras', country: 'MX'},
              { id: 606, description:'Arrendamiento', country: 'MX'},
              { id: 624, description:'Coordinados', country: 'MX'},
              { id: 608, description:'Demás ingresos', country: 'MX'},
              { id: 621, description:'Incorporación Fiscal', country: 'MX'},
              { id: 611, description:'Ingresos por Dividendos (socios y accionistas)', country: 'MX'},
              { id: 614, description:'Ingresos por intereses', country: 'MX'},
              { id: 623, description:'Opcional para Grupos de Sociedades', country: 'MX'},
              { id: 612, description:'Personas Físicas con Actividades Empresariales y Profesionales', country: 'MX'},
              { id: 603, description:'Personas Morales con Fines no Lucrativos', country: 'MX'},
              { id: 607, description:'Régimen de Enajenación o Adquisición de Bienes', country: 'MX'},
              { id: 625, description:'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas', country: 'MX'},
              { id: 615, description:'Régimen de los ingresos por obtención de premios', country: 'MX'},
              { id: 601, description:'Régimen General de Ley Personas Morales', country: 'MX'},
              { id: 626, description:'Régimen Simplificado de Confianza', country: 'MX'},
              { id: 610, description:'Residentes en el Extranjero sin Establecimiento Permanente en México', country: 'MX'},
              { id: 616, description:'Sin obligaciones fiscales', country: 'MX'},
              { id: 620, description:'Sociedades Cooperativas de Producción que optan por diferir sus ingresos', country: 'MX'},
              { id: 605, description:'Sueldos y Salarios e Ingresos Asimilados a Salarios', country: 'MX'},
          )
          break;
      case 'CO':
          taxRegimeOptions.push(
              { id: 49, description: 'No responsable de IVA', country: 'CO'},
              { id: 48, description: 'Responsable de impuesto Iva', country: 'CO'},                    
            )
        break;
    }

    return taxRegimeOptions;
}

export const getCFDIOptions = (country: string) => {
  const cfdiOptions: CFDI[] = []
  if (country == 'MX') {
      cfdiOptions.push(
          { id: 'G01', description: 'Adquisición de mercancías'},
          { id: 'G02', description: 'Devoluciones, descuentos o bonificaciones'}, 
          { id: 'I04', description: 'Equipo de computo y accesorios'}, 
          { id: 'G03', description: 'Gastos en general'}, 
          { id: 'I02', description: 'Mobiliario y equipo de oficina por inversiones'}, 
          { id: 'I08', description: 'Otra maquinaria y equipo'}, 
          { id: 'S01', description: 'Sin efectos fiscales'}, 
      )
  }
  return cfdiOptions;
}

export const getPersonTypeOptions = (country: string) => {
  const personTypeOptions: PersonType[] = []
  if (country == 'CO') {
      personTypeOptions.push(
          { id: 1, description: 'Persona juridica'}, 
          { id: 2, description: 'Persona natural'}, 
      )
  }
  return personTypeOptions
}

export const getIdentificationTypeOptions = (country: string) => {
  const identificationTypeOptions: IdentificationType[] = []
  if (country == 'ES') {
      identificationTypeOptions.push(
          { id: 1, description: 'Ciudadano Español'},
          { id: 2, description: 'Ciudadano Residente'},
          { id: 3, description: 'Empresa Española'},
          { id: 4, description: 'Residente Fuera de España'},
      )
  }
  return identificationTypeOptions
}

export const getDocumentTypeOptions = (country: string) => {
  const documentTypeOptions: DocumentType[] = []
  if (country == 'CO') {
    documentTypeOptions.push(
          { id: 3, description: 'Cédula de ciudadanía'},
          { id: 5, description: 'Cédula de extranjería'},
          { id: 8, description: 'Documento de identificación extranjero'},
          { id: 6, description: 'NIT'},
          { id: 7, description: 'Pasaporte'},
          { id: 1, description: 'Registro civil'},
          { id: 4, description: 'Tarjeta de extranjería'},
          { id: 2, description: 'Tarjeta de identidad'},
      )
  }       
  return documentTypeOptions 
}

export const getRegions = (country: string) => {
  const regionOptions: Region[] = [];
  if (country == 'CO') {
      regionOptions.push(
          { id: 91, description: 'Amazonas'},
          { id: 5, description: 'Antioquia'},
          { id: 81, description: 'Arauca'},
          { id: 8, description: 'Atlántico'},
          { id: 11, description: 'Bogotá D.C.'},
          { id: 13, description: 'Bolívar'},
          { id: 15, description: 'Boyacá'},
          { id: 17, description: 'Caldas'},
          { id: 18, description: 'Caquetá'},
          { id: 85, description: 'Casanare'},
          { id: 19, description: 'Cauca'},
          { id: 20, description: 'Cesar'},
          { id: 27, description: 'Chocó'},
          { id: 23, description: 'Córdoba'},
          { id: 25, description: 'Cundinamarca'},
          { id: 94, description: 'Guainía'},
          { id: 95, description: 'Guaviare'},
          { id: 41, description: 'Huila'},
          { id: 44, description: 'La Guajira'},
          { id: 47, description: 'Magdalena'},
          { id: 50, description: 'Meta'},
          { id: 52, description: 'Nariño'},
          { id: 54, description: 'Norte de Santander'},
          { id: 86, description: 'Putumayo'},
          { id: 63, description: 'Quindío'},
          { id: 66, description: 'Risaralda'},
          { id: 88, description: 'San Andrés'},
          { id: 68, description: 'Santander'},
          { id: 70, description: 'Sucre'},
          { id: 73, description: 'Tolima'},
          { id: 76, description: 'Valle del Cauca'},
          { id: 97, description: 'Vaupés'},
          { id: 99, description: 'Vichada'},
          )
  }
  return regionOptions
}

export const getRepresentations = (country: string) => {
  const options: Representacion[] = [];
  if (country == 'CO') {
      options.push(
            { id: '01', name: 'Administrador judicial', description:'Persona designada por autoridad competente para administrar la comunidad, cuando los comuneros no se avinieren en el manejo del bien común.'} , 
            { id: '02', name: 'Administrador privado', description:'Persona designada por los comuneros para administrar la comunidad.'} , 
            { id: '03', name: 'Agente exclusivo de negocios en Colombia', description:'persona encargada de la representación de residentes en el exterior en los casos en que sean apoderados de éstos para cumplir las obligaciones fiscales.'} , 
            { id: '04', name: 'Agente oficioso', description:'Figura jurídica por la cual el que administra sin mandato los bienes de alguna persona, se obliga para con ésta, y la obliga en ciertos casos.'} , 
            { id: '05', name: 'Albacea', description:'Persona encargada por el testador o por el juez de cumplir la última voluntad del testador, custodiando sus bienes y dándoles el destino que corresponde según la herencia.'} , 
            { id: '06', name: 'Apoderado especial', description:'Persona que acepta el mandato de uno o mas negocios especialmente determinados.'} , 
            { id: '07', name: 'Apoderado general', description:'Persona que acepta el mandato de todos los negocios del mandante, o lo admite con una o mas excepciones determinadas.'} , 
            { id: '08', name: 'Asignatario', description:'Persona a quien se le asigna la herencia o legado.'} , 
            { id: '09', name: 'Comunero', description:'Persona que participa en una comunidad de bienes o derechos.'} , 
            { id: '10', name: 'Curador', description:'Persona elegida o designada, para cuidar de los sujetos y/o bienes o negocios, de quienes por ley no pueden dirigirse a si mismos , o administrar completamente sus negocios y que no se encuentran bajo potestad de padre que pueda darles la protección debida. (menor adulto, demente, sordomudo que no pueda darse a entender por escrito, prodigo o disipador en interdicción, herencia yacente, hijo póstumo, entre otros ).'} , 
            { id: '11', name: 'Donatario', description:'Persona a quien se hace la donación, mediante un acto por el cual se le transfiere gratuita e irrevocablemente, una parte de los bienes del donante.'} , 
            { id: '12', name: 'Factor', description:'Mandatario encargado de la administración de un establecimiento de comercio, o de una parte o ramo de la actividad del mismo.'} , 
            { id: '13', name: 'Funcionario delegado para cumplir deberes formales', description:'Persona a quien se le delega conforme a derecho, la responsabilidad de cumplir los deberes formales por el representado.'} , 
            { id: '14', name: 'Heredero con administración de bienes', description:'Persona que representa al testador para sucederlo en todos sus derechos y obligaciones transmisibles, a quien adicionalmente se le ha asignado la administración de los bienes.'} , 
            { id: '15', name: 'Liquidador', description:'Persona que concluirá las operaciones sociales pendientes al tiempo de la apertura del trámite liquidatorio; realiza o dispone de los bienes del deudor para atender el pago de las obligaciones del ente en liquidación.'} , 
            { id: '16', name: 'Mandatario', description:'Persona que, en virtud del contrato consensual llamado mandato, acepta del mandante representarlo personalmente, o la gestión o desempeño de uno o más negocios.'} , 
            { id: '17', name: 'Padre', description:'Persona natural que debe cumplir los deberes formales por sus hijos menores, en los casos en que el impuesto deba liquidarse directamente a estos.'} , 
            { id: '18', name: 'Representante legal principal', description:'Persona autorizada por la organización para representarla ante las diferentes entidades, administrar sus bienes y cumplir ciertos deberes legales y estatutarios. Para el ejercicio de las funciones debe estar previamente registrado ante la autoridad competente, o poseer esta calidad por mandato legal.'} , 
            { id: '19', name: 'Representante legal suplente', description:'Persona autorizada por la organización para representarla ante las diferentes entidades,, administrar sus bienes y cumplir ciertos deberes legales y estatutarios en calidad de suplente. Para el ejercicio de las funciones debe estar previamente registrada ante la autoridad competente, o poseer esta calidad por mandato legal.'} , 
            { id: '20', name: 'Síindico', description:'Persona que tiene la guarda y administración de la masa de bienes de la quiebra.'} , 
            { id: '21', name: 'Tutor', description:'Persona a que quien se le impone el cargo a favor de los impúberes que no pueden dirigirse a si mismos o administrar completamente sus negocios, siempre que no estén bajo potestad del padre que pueda darle la protección debida; incluye igualmente el hijo póstumo.'} ,
          )
  }
  return options
}

export const getCities = (country: string, regionId: number) => {
    return loadCities(country).filter(city => city.regionId === regionId);
}

export const loadCities = (country: string) => {
  const cityOptions: City[] = [];
  if (country == 'CO') {
      cityOptions.push(
          { id: '91263', regionId: 91, name: 'El Encanto', country: 'CO'},
          { id: '91405', regionId: 91, name: 'La Chorrera', country: 'CO'},
          { id: '91407', regionId: 91, name: 'La Pedrera', country: 'CO'},
          { id: '91430', regionId: 91, name: 'La Victoria', country: 'CO'},
          { id: '91001', regionId: 91, name: 'Leticia', country: 'CO'},
          { id: '91460', regionId: 91, name: 'Miriti-Parana', country: 'CO'},
          { id: '91530', regionId: 91, name: 'Puerto Alegria', country: 'CO'},
          { id: '91536', regionId: 91, name: 'Puerto Arica', country: 'CO'},
          { id: '91540', regionId: 91, name: 'Puerto Nariño', country: 'CO'},
          { id: '91669', regionId: 91, name: 'Puerto Santander', country: 'CO'},
          { id: '91798', regionId: 91, name: 'Tarapaca', country: 'CO'},
          { id: '05002', regionId: 5, name: 'Abejorral', country: 'CO'},
          { id: '05004', regionId: 5, name: 'Abriaqui', country: 'CO'},
          { id: '05021', regionId: 5, name: 'Alejandria', country: 'CO'},
          { id: '05030', regionId: 5, name: 'Amaga', country: 'CO'},
          { id: '05031', regionId: 5, name: 'Amalfi', country: 'CO'},
          { id: '05034', regionId: 5, name: 'Andes', country: 'CO'},
          { id: '05036', regionId: 5, name: 'Angelopolis', country: 'CO'},
          { id: '05038', regionId: 5, name: 'Angostura', country: 'CO'},
          { id: '05040', regionId: 5, name: 'Anori', country: 'CO'},
          { id: '05042', regionId: 5, name: 'Antioquia', country: 'CO'},
          { id: '05044', regionId: 5, name: 'Anza', country: 'CO'},
          { id: '05045', regionId: 5, name: 'Apartado', country: 'CO'},
          { id: '05051', regionId: 5, name: 'Arboletes', country: 'CO'},
          { id: '05055', regionId: 5, name: 'Argelia', country: 'CO'},
          { id: '05059', regionId: 5, name: 'Armenia', country: 'CO'},
          { id: '05079', regionId: 5, name: 'Barbosa', country: 'CO'},
          { id: '05088', regionId: 5, name: 'Bello', country: 'CO'},
          { id: '05086', regionId: 5, name: 'Belmira', country: 'CO'},
          { id: '05091', regionId: 5, name: 'Betania', country: 'CO'},
          { id: '05093', regionId: 5, name: 'Betulia', country: 'CO'},
          { id: '05101', regionId: 5, name: 'Bolivar', country: 'CO'},
          { id: '05107', regionId: 5, name: 'Briceño', country: 'CO'},
          { id: '05113', regionId: 5, name: 'Buritica', country: 'CO'},
          { id: '05120', regionId: 5, name: 'Caceres', country: 'CO'},
          { id: '05125', regionId: 5, name: 'Caicedo', country: 'CO'},
          { id: '05129', regionId: 5, name: 'Caldas', country: 'CO'},
          { id: '05134', regionId: 5, name: 'Campamento', country: 'CO'},
          { id: '05138', regionId: 5, name: 'Cañasgordas', country: 'CO'},
          { id: '05142', regionId: 5, name: 'Caracoli', country: 'CO'},
          { id: '05145', regionId: 5, name: 'Caramanta', country: 'CO'},
          { id: '05147', regionId: 5, name: 'Carepa', country: 'CO'},
          { id: '05148', regionId: 5, name: 'Carmen De Viboral', country: 'CO'},
          { id: '05150', regionId: 5, name: 'Carolina', country: 'CO'},
          { id: '05154', regionId: 5, name: 'Caucasia', country: 'CO'},
          { id: '05172', regionId: 5, name: 'Chigorodo', country: 'CO'},
          { id: '05190', regionId: 5, name: 'Cisneros', country: 'CO'},
          { id: '05197', regionId: 5, name: 'Cocorna', country: 'CO'},
          { id: '05206', regionId: 5, name: 'Concepcion', country: 'CO'},
          { id: '05209', regionId: 5, name: 'Concordia', country: 'CO'},
          { id: '05212', regionId: 5, name: 'Copacabana', country: 'CO'},
          { id: '05234', regionId: 5, name: 'Dabeiba', country: 'CO'},
          { id: '05237', regionId: 5, name: 'Don Matias', country: 'CO'},
          { id: '05240', regionId: 5, name: 'Ebejico', country: 'CO'},
          { id: '05250', regionId: 5, name: 'El Bagre', country: 'CO'},
          { id: '05264', regionId: 5, name: 'Entrerrios', country: 'CO'},
          { id: '05266', regionId: 5, name: 'Envigado', country: 'CO'},
          { id: '05282', regionId: 5, name: 'Fredonia', country: 'CO'},
          { id: '05284', regionId: 5, name: 'Frontino', country: 'CO'},
          { id: '05306', regionId: 5, name: 'Giraldo', country: 'CO'},
          { id: '05308', regionId: 5, name: 'Girardota', country: 'CO'},
          { id: '05310', regionId: 5, name: 'Gomez Plata', country: 'CO'},
          { id: '05313', regionId: 5, name: 'Granada', country: 'CO'},
          { id: '05315', regionId: 5, name: 'Guadalupe', country: 'CO'},
          { id: '05318', regionId: 5, name: 'Guarne', country: 'CO'},
          { id: '05321', regionId: 5, name: 'Guatape', country: 'CO'},
          { id: '05347', regionId: 5, name: 'Heliconia', country: 'CO'},
          { id: '05353', regionId: 5, name: 'Hispania', country: 'CO'},
          { id: '05360', regionId: 5, name: 'Itagui', country: 'CO'},
          { id: '05361', regionId: 5, name: 'Ituango', country: 'CO'},
          { id: '05364', regionId: 5, name: 'Jardin', country: 'CO'},
          { id: '05368', regionId: 5, name: 'Jerico', country: 'CO'},
          { id: '05376', regionId: 5, name: 'La Ceja', country: 'CO'},
          { id: '05380', regionId: 5, name: 'La Estrella', country: 'CO'},
          { id: '05390', regionId: 5, name: 'La Pintada', country: 'CO'},
          { id: '05400', regionId: 5, name: 'La Union', country: 'CO'},
          { id: '05411', regionId: 5, name: 'Liborina', country: 'CO'},
          { id: '05425', regionId: 5, name: 'Maceo', country: 'CO'},
          { id: '05440', regionId: 5, name: 'Marinilla', country: 'CO'},
          { id: '05001', regionId: 5, name: 'Medellin', country: 'CO'},
          { id: '05467', regionId: 5, name: 'Montebello', country: 'CO'},
          { id: '05475', regionId: 5, name: 'Murindo', country: 'CO'},
          { id: '05480', regionId: 5, name: 'Mutata', country: 'CO'},
          { id: '05483', regionId: 5, name: 'Nariño', country: 'CO'},
          { id: '05495', regionId: 5, name: 'Nechi', country: 'CO'},
          { id: '05490', regionId: 5, name: 'Necocli', country: 'CO'},
          { id: '05501', regionId: 5, name: 'Olaya', country: 'CO'},
          { id: '05541', regionId: 5, name: 'Peñol', country: 'CO'},
          { id: '05543', regionId: 5, name: 'Peque', country: 'CO'},
          { id: '05576', regionId: 5, name: 'Pueblorrico', country: 'CO'},
          { id: '05579', regionId: 5, name: 'Puerto Berrio', country: 'CO'},
          { id: '05585', regionId: 5, name: 'Puerto Nare (La Magdalena)', country: 'CO'},
          { id: '05591', regionId: 5, name: 'Puerto Triunfo', country: 'CO'},
          { id: '05604', regionId: 5, name: 'Remedios', country: 'CO'},
          { id: '05607', regionId: 5, name: 'Retiro', country: 'CO'},
          { id: '05615', regionId: 5, name: 'Rionegro', country: 'CO'},
          { id: '05628', regionId: 5, name: 'Sabanalarga', country: 'CO'},
          { id: '05631', regionId: 5, name: 'Sabaneta', country: 'CO'},
          { id: '05642', regionId: 5, name: 'Salgar', country: 'CO'},
          { id: '05647', regionId: 5, name: 'San Andres', country: 'CO'},
          { id: '05649', regionId: 5, name: 'San Carlos', country: 'CO'},
          { id: '05652', regionId: 5, name: 'San Francisco', country: 'CO'},
          { id: '05656', regionId: 5, name: 'San Jeronimo', country: 'CO'},
          { id: '05658', regionId: 5, name: 'San Jose De La Montaña', country: 'CO'},
          { id: '05659', regionId: 5, name: 'San Juan De Uraba', country: 'CO'},
          { id: '05660', regionId: 5, name: 'San Luis', country: 'CO'},
          { id: '05664', regionId: 5, name: 'San Pedro', country: 'CO'},
          { id: '05665', regionId: 5, name: 'San Pedro De Uraba', country: 'CO'},
          { id: '05667', regionId: 5, name: 'San Rafael', country: 'CO'},
          { id: '05670', regionId: 5, name: 'San Roque', country: 'CO'},
          { id: '05674', regionId: 5, name: 'San Vicente', country: 'CO'},
          { id: '05679', regionId: 5, name: 'Santa Barbara', country: 'CO'},
          { id: '05686', regionId: 5, name: 'Santa Rosa De Osos', country: 'CO'},
          { id: '05690', regionId: 5, name: 'Santo Domingo', country: 'CO'},
          { id: '05697', regionId: 5, name: 'Santuario', country: 'CO'},
          { id: '05736', regionId: 5, name: 'Segovia', country: 'CO'},
          { id: '05756', regionId: 5, name: 'Sonson', country: 'CO'},
          { id: '05761', regionId: 5, name: 'Sopetran', country: 'CO'},
          { id: '05789', regionId: 5, name: 'Tamesis', country: 'CO'},
          { id: '05790', regionId: 5, name: 'Taraza', country: 'CO'},
          { id: '05792', regionId: 5, name: 'Tarso', country: 'CO'},
          { id: '05809', regionId: 5, name: 'Titiribi', country: 'CO'},
          { id: '05819', regionId: 5, name: 'Toledo', country: 'CO'},
          { id: '05837', regionId: 5, name: 'Turbo', country: 'CO'},
          { id: '05842', regionId: 5, name: 'Uramita', country: 'CO'},
          { id: '05847', regionId: 5, name: 'Urrao', country: 'CO'},
          { id: '05854', regionId: 5, name: 'Valdivia', country: 'CO'},
          { id: '05856', regionId: 5, name: 'Valparaiso', country: 'CO'},
          { id: '05858', regionId: 5, name: 'Vegachi', country: 'CO'},
          { id: '05861', regionId: 5, name: 'Venecia', country: 'CO'},
          { id: '05873', regionId: 5, name: 'Vigia Del Fuerte', country: 'CO'},
          { id: '05885', regionId: 5, name: 'Yali', country: 'CO'},
          { id: '05887', regionId: 5, name: 'Yarumal', country: 'CO'},
          { id: '05890', regionId: 5, name: 'Yolombo', country: 'CO'},
          { id: '05893', regionId: 5, name: 'Yondo', country: 'CO'},
          { id: '05895', regionId: 5, name: 'Zaragoza', country: 'CO'},
          { id: '81001', regionId: 81, name: 'Arauca', country: 'CO'},
          { id: '81065', regionId: 81, name: 'Arauquita', country: 'CO'},
          { id: '81220', regionId: 81, name: 'Cravo Norte', country: 'CO'},
          { id: '81300', regionId: 81, name: 'Fortul', country: 'CO'},
          { id: '81591', regionId: 81, name: 'Puerto Rondon', country: 'CO'},
          { id: '81736', regionId: 81, name: 'Saravena', country: 'CO'},
          { id: '81794', regionId: 81, name: 'Tame', country: 'CO'},
          { id: '08078', regionId: 8, name: 'Baranoa', country: 'CO'},
          { id: '08001', regionId: 8, name: 'Barranquilla (Distrito Especial, Industrial Y Portuario De Barranquilla)', country: 'CO'},
          { id: '08137', regionId: 8, name: 'Campo De La Cruz', country: 'CO'},
          { id: '08141', regionId: 8, name: 'Candelaria', country: 'CO'},
          { id: '08296', regionId: 8, name: 'Galapa', country: 'CO'},
          { id: '08372', regionId: 8, name: 'Juan De Acosta', country: 'CO'},
          { id: '08421', regionId: 8, name: 'Luruaco', country: 'CO'},
          { id: '08433', regionId: 8, name: 'Malambo', country: 'CO'},
          { id: '08436', regionId: 8, name: 'Manati', country: 'CO'},
          { id: '08520', regionId: 8, name: 'Palmar De Varela', country: 'CO'},
          { id: '08549', regionId: 8, name: 'Piojo', country: 'CO'},
          { id: '08558', regionId: 8, name: 'Polo Nuevo', country: 'CO'},
          { id: '08560', regionId: 8, name: 'Ponedera', country: 'CO'},
          { id: '08573', regionId: 8, name: 'Puerto Colombia', country: 'CO'},
          { id: '08606', regionId: 8, name: 'Repelon', country: 'CO'},
          { id: '08634', regionId: 8, name: 'Sabanagrande', country: 'CO'},
          { id: '08638', regionId: 8, name: 'Sabanalarga', country: 'CO'},
          { id: '08675', regionId: 8, name: 'Santa Lucia', country: 'CO'},
          { id: '08685', regionId: 8, name: 'Santo Tomas', country: 'CO'},
          { id: '08758', regionId: 8, name: 'Soledad', country: 'CO'},
          { id: '08770', regionId: 8, name: 'Suan', country: 'CO'},
          { id: '08832', regionId: 8, name: 'Tubara', country: 'CO'},
          { id: '08849', regionId: 8, name: 'Usiacuri', country: 'CO'},
          { id: '11015', regionId: 11, name: 'Antonio Nariño', country: 'CO'},
          { id: '11012', regionId: 11, name: 'Barrios Unidos', country: 'CO'},
          { id: '11001', regionId: 11, name: 'Bogotá, D. C.', country: 'CO'},
          { id: '11007', regionId: 11, name: 'Bosa', country: 'CO'},
          { id: '11017', regionId: 11, name: 'Candelaria', country: 'CO'},
          { id: '11002', regionId: 11, name: 'Chapinero', country: 'CO'},
          { id: '11019', regionId: 11, name: 'Ciudad Bolivar', country: 'CO'},
          { id: '11010', regionId: 11, name: 'Engativa', country: 'CO'},
          { id: '11009', regionId: 11, name: 'Fontibon', country: 'CO'},
          { id: '11008', regionId: 11, name: 'Kennedy', country: 'CO'},
          { id: '11014', regionId: 11, name: 'Martires', country: 'CO'},
          { id: '11016', regionId: 11, name: 'Puente Aranda', country: 'CO'},
          { id: '11018', regionId: 11, name: 'Rafael Uribe', country: 'CO'},
          { id: '11004', regionId: 11, name: 'San Cristobal', country: 'CO'},
          { id: '11003', regionId: 11, name: 'Santa Fe', country: 'CO'},
          { id: '11011', regionId: 11, name: 'Suba', country: 'CO'},
          { id: '11020', regionId: 11, name: 'Sumapaz', country: 'CO'},
          { id: '11013', regionId: 11, name: 'Teusaquillo', country: 'CO'},
          { id: '11006', regionId: 11, name: 'Tunjuelito', country: 'CO'},
          { id: '11001', regionId: 11, name: 'Usaquen', country: 'CO'},
          { id: '11005', regionId: 11, name: 'Usme', country: 'CO'},
          { id: '13006', regionId: 13, name: 'Achi', country: 'CO'},
          { id: '13030', regionId: 13, name: 'Altos Del Rosario', country: 'CO'},
          { id: '13042', regionId: 13, name: 'Arenal', country: 'CO'},
          { id: '13052', regionId: 13, name: 'Arjona', country: 'CO'},
          { id: '13062', regionId: 13, name: 'Arroyohondo', country: 'CO'},
          { id: '13074', regionId: 13, name: 'Barranco De Loba', country: 'CO'},
          { id: '13140', regionId: 13, name: 'Calamar', country: 'CO'},
          { id: '13160', regionId: 13, name: 'Cantagallo', country: 'CO'},
          { id: '13001', regionId: 13, name: 'Cartagena (Distrito Turistico Y Cultural De Cartagena)', country: 'CO'},
          { id: '13188', regionId: 13, name: 'Cicuco', country: 'CO'},
          { id: '13222', regionId: 13, name: 'Clemencia', country: 'CO'},
          { id: '13212', regionId: 13, name: 'Cordoba', country: 'CO'},
          { id: '13244', regionId: 13, name: 'El Carmen De Bolivar', country: 'CO'},
          { id: '13248', regionId: 13, name: 'El Guamo', country: 'CO'},
          { id: '13268', regionId: 13, name: 'El Peñon', country: 'CO'},
          { id: '13300', regionId: 13, name: 'Hatillo De Loba', country: 'CO'},
          { id: '13430', regionId: 13, name: 'Magangue', country: 'CO'},
          { id: '13433', regionId: 13, name: 'Mahates', country: 'CO'},
          { id: '13440', regionId: 13, name: 'Margarita', country: 'CO'},
          { id: '13442', regionId: 13, name: 'Maria La Baja', country: 'CO'},
          { id: '13468', regionId: 13, name: 'Mompos', country: 'CO'},
          { id: '13458', regionId: 13, name: 'Montecristo', country: 'CO'},
          { id: '13473', regionId: 13, name: 'Morales', country: 'CO'},
          { id: '13549', regionId: 13, name: 'Pinillos', country: 'CO'},
          { id: '13580', regionId: 13, name: 'Regidor', country: 'CO'},
          { id: '13600', regionId: 13, name: 'Rio Viejo', country: 'CO'},
          { id: '13620', regionId: 13, name: 'San Cristobal', country: 'CO'},
          { id: '13647', regionId: 13, name: 'San Estanislao', country: 'CO'},
          { id: '13650', regionId: 13, name: 'San Fernando', country: 'CO'},
          { id: '13654', regionId: 13, name: 'San Jacinto', country: 'CO'},
          { id: '13655', regionId: 13, name: 'San Jacinto Del Cauca', country: 'CO'},
          { id: '13657', regionId: 13, name: 'San Juan Nepomuceno', country: 'CO'},
          { id: '13667', regionId: 13, name: 'San Martin De Loba', country: 'CO'},
          { id: '13670', regionId: 13, name: 'San Pablo', country: 'CO'},
          { id: '13673', regionId: 13, name: 'Santa Catalina', country: 'CO'},
          { id: '13683', regionId: 13, name: 'Santa Rosa', country: 'CO'},
          { id: '13688', regionId: 13, name: 'Santa Rosa Del Sur', country: 'CO'},
          { id: '13744', regionId: 13, name: 'Simiti', country: 'CO'},
          { id: '13760', regionId: 13, name: 'Soplaviento', country: 'CO'},
          { id: '13780', regionId: 13, name: 'Talaigua Nuevo', country: 'CO'},
          { id: '13810', regionId: 13, name: 'Tiquisio (Puerto Rico)', country: 'CO'},
          { id: '13836', regionId: 13, name: 'Turbaco', country: 'CO'},
          { id: '13838', regionId: 13, name: 'Turbana', country: 'CO'},
          { id: '13873', regionId: 13, name: 'Villanueva', country: 'CO'},
          { id: '13894', regionId: 13, name: 'Zambrano', country: 'CO'},
          { id: '15022', regionId: 15, name: 'Almeida', country: 'CO'},
          { id: '15047', regionId: 15, name: 'Aquitania', country: 'CO'},
          { id: '15051', regionId: 15, name: 'Arcabuco', country: 'CO'},
          { id: '15087', regionId: 15, name: 'Belen', country: 'CO'},
          { id: '15090', regionId: 15, name: 'Berbeo', country: 'CO'},
          { id: '15092', regionId: 15, name: 'Beteitiva', country: 'CO'},
          { id: '15097', regionId: 15, name: 'Boavita', country: 'CO'},
          { id: '15104', regionId: 15, name: 'Boyaca', country: 'CO'},
          { id: '15106', regionId: 15, name: 'Briceño', country: 'CO'},
          { id: '15109', regionId: 15, name: 'Buenavista', country: 'CO'},
          { id: '15114', regionId: 15, name: 'Busbanza', country: 'CO'},
          { id: '15131', regionId: 15, name: 'Caldas', country: 'CO'},
          { id: '15135', regionId: 15, name: 'Campohermoso', country: 'CO'},
          { id: '15162', regionId: 15, name: 'Cerinza', country: 'CO'},
          { id: '15172', regionId: 15, name: 'Chinavita', country: 'CO'},
          { id: '15176', regionId: 15, name: 'Chiquinquira', country: 'CO'},
          { id: '15232', regionId: 15, name: 'Chiquiza', country: 'CO'},
          { id: '15180', regionId: 15, name: 'Chiscas', country: 'CO'},
          { id: '15183', regionId: 15, name: 'Chita', country: 'CO'},
          { id: '15185', regionId: 15, name: 'Chitaraque', country: 'CO'},
          { id: '15187', regionId: 15, name: 'Chivata', country: 'CO'},
          { id: '15236', regionId: 15, name: 'Chivor', country: 'CO'},
          { id: '15189', regionId: 15, name: 'Cienega', country: 'CO'},
          { id: '15204', regionId: 15, name: 'Combita', country: 'CO'},
          { id: '15212', regionId: 15, name: 'Coper', country: 'CO'},
          { id: '15215', regionId: 15, name: 'Corrales', country: 'CO'},
          { id: '15218', regionId: 15, name: 'Covarachia', country: 'CO'},
          { id: '15223', regionId: 15, name: 'Cubara', country: 'CO'},
          { id: '15224', regionId: 15, name: 'Cucaita', country: 'CO'},
          { id: '15226', regionId: 15, name: 'Cuitiva', country: 'CO'},
          { id: '15238', regionId: 15, name: 'Duitama', country: 'CO'},
          { id: '15244', regionId: 15, name: 'El Cocuy', country: 'CO'},
          { id: '15248', regionId: 15, name: 'El Espino', country: 'CO'},
          { id: '15272', regionId: 15, name: 'Firavitoba', country: 'CO'},
          { id: '15276', regionId: 15, name: 'Floresta', country: 'CO'},
          { id: '15293', regionId: 15, name: 'Gachantiva', country: 'CO'},
          { id: '15296', regionId: 15, name: 'Gameza', country: 'CO'},
          { id: '15299', regionId: 15, name: 'Garagoa', country: 'CO'},
          { id: '15317', regionId: 15, name: 'Guacamayas', country: 'CO'},
          { id: '15322', regionId: 15, name: 'Guateque', country: 'CO'},
          { id: '15325', regionId: 15, name: 'Guayata', country: 'CO'},
          { id: '15332', regionId: 15, name: 'Guican', country: 'CO'},
          { id: '15362', regionId: 15, name: 'Iza', country: 'CO'},
          { id: '15367', regionId: 15, name: 'Jenesano', country: 'CO'},
          { id: '15368', regionId: 15, name: 'Jerico', country: 'CO'},
          { id: '15380', regionId: 15, name: 'La Capilla', country: 'CO'},
          { id: '15403', regionId: 15, name: 'La Uvita', country: 'CO'},
          { id: '15401', regionId: 15, name: 'La Victoria', country: 'CO'},
          { id: '15377', regionId: 15, name: 'Labranzagrande', country: 'CO'},
          { id: '15425', regionId: 15, name: 'Macanal', country: 'CO'},
          { id: '15442', regionId: 15, name: 'Maripi', country: 'CO'},
          { id: '15455', regionId: 15, name: 'Miraflores', country: 'CO'},
          { id: '15464', regionId: 15, name: 'Mongua', country: 'CO'},
          { id: '15466', regionId: 15, name: 'Mongui', country: 'CO'},
          { id: '15469', regionId: 15, name: 'Moniquira', country: 'CO'},
          { id: '15476', regionId: 15, name: 'Motavita', country: 'CO'},
          { id: '15480', regionId: 15, name: 'Muzo', country: 'CO'},
          { id: '15491', regionId: 15, name: 'Nobsa', country: 'CO'},
          { id: '15494', regionId: 15, name: 'Nuevo Colon', country: 'CO'},
          { id: '15500', regionId: 15, name: 'Oicata', country: 'CO'},
          { id: '15507', regionId: 15, name: 'Otanche', country: 'CO'},
          { id: '15511', regionId: 15, name: 'Pachavita', country: 'CO'},
          { id: '15514', regionId: 15, name: 'Paez', country: 'CO'},
          { id: '15516', regionId: 15, name: 'Paipa', country: 'CO'},
          { id: '15518', regionId: 15, name: 'Pajarito', country: 'CO'},
          { id: '15522', regionId: 15, name: 'Panqueba', country: 'CO'},
          { id: '15531', regionId: 15, name: 'Pauna', country: 'CO'},
          { id: '15533', regionId: 15, name: 'Paya', country: 'CO'},
          { id: '15537', regionId: 15, name: 'Paz Del Rio', country: 'CO'},
          { id: '15542', regionId: 15, name: 'Pesca', country: 'CO'},
          { id: '15550', regionId: 15, name: 'Pisba', country: 'CO'},
          { id: '15572', regionId: 15, name: 'Puerto Boyaca', country: 'CO'},
          { id: '15580', regionId: 15, name: 'Quipama', country: 'CO'},
          { id: '15599', regionId: 15, name: 'Ramiriqui', country: 'CO'},
          { id: '15600', regionId: 15, name: 'Raquira', country: 'CO'},
          { id: '15621', regionId: 15, name: 'Rondon', country: 'CO'},
          { id: '15632', regionId: 15, name: 'Saboya', country: 'CO'},
          { id: '15638', regionId: 15, name: 'Sachica', country: 'CO'},
          { id: '15646', regionId: 15, name: 'Samaca', country: 'CO'},
          { id: '15660', regionId: 15, name: 'San Eduardo', country: 'CO'},
          { id: '15664', regionId: 15, name: 'San Jose De Pare', country: 'CO'},
          { id: '15667', regionId: 15, name: 'San Luis De Gaceno', country: 'CO'},
          { id: '15673', regionId: 15, name: 'San Mateo', country: 'CO'},
          { id: '15676', regionId: 15, name: 'San Miguel De Sema', country: 'CO'},
          { id: '15681', regionId: 15, name: 'San Pablo De Borbur', country: 'CO'},
          { id: '15690', regionId: 15, name: 'Santa Maria', country: 'CO'},
          { id: '15693', regionId: 15, name: 'Santa Rosa De Viterbo', country: 'CO'},
          { id: '15696', regionId: 15, name: 'Santa Sofia', country: 'CO'},
          { id: '15686', regionId: 15, name: 'Santana', country: 'CO'},
          { id: '15720', regionId: 15, name: 'Sativanorte', country: 'CO'},
          { id: '15723', regionId: 15, name: 'Sativasur', country: 'CO'},
          { id: '15740', regionId: 15, name: 'Siachoque', country: 'CO'},
          { id: '15753', regionId: 15, name: 'Soata', country: 'CO'},
          { id: '15757', regionId: 15, name: 'Socha', country: 'CO'},
          { id: '15755', regionId: 15, name: 'Socota', country: 'CO'},
          { id: '15759', regionId: 15, name: 'Sogamoso', country: 'CO'},
          { id: '15761', regionId: 15, name: 'Somondoco', country: 'CO'},
          { id: '15762', regionId: 15, name: 'Sora', country: 'CO'},
          { id: '15764', regionId: 15, name: 'Soraca', country: 'CO'},
          { id: '15763', regionId: 15, name: 'Sotaquira', country: 'CO'},
          { id: '15774', regionId: 15, name: 'Susacon', country: 'CO'},
          { id: '15776', regionId: 15, name: 'Sutamarchan', country: 'CO'},
          { id: '15778', regionId: 15, name: 'Sutatenza', country: 'CO'},
          { id: '15790', regionId: 15, name: 'Tasco', country: 'CO'},
          { id: '15798', regionId: 15, name: 'Tenza', country: 'CO'},
          { id: '15804', regionId: 15, name: 'Tibana', country: 'CO'},
          { id: '15806', regionId: 15, name: 'Tibasosa', country: 'CO'},
          { id: '15808', regionId: 15, name: 'Tinjaca', country: 'CO'},
          { id: '15810', regionId: 15, name: 'Tipacoque', country: 'CO'},
          { id: '15814', regionId: 15, name: 'Toca', country: 'CO'},
          { id: '15816', regionId: 15, name: 'Togui', country: 'CO'},
          { id: '15820', regionId: 15, name: 'Topaga', country: 'CO'},
          { id: '15822', regionId: 15, name: 'Tota', country: 'CO'},
          { id: '15001', regionId: 15, name: 'Tunja', country: 'CO'},
          { id: '15832', regionId: 15, name: 'Tunungua', country: 'CO'},
          { id: '15835', regionId: 15, name: 'Turmeque', country: 'CO'},
          { id: '15837', regionId: 15, name: 'Tuta', country: 'CO'},
          { id: '15839', regionId: 15, name: 'Tutasa', country: 'CO'},
          { id: '15842', regionId: 15, name: 'Umbita', country: 'CO'},
          { id: '15861', regionId: 15, name: 'Ventaquemada', country: 'CO'},
          { id: '15407', regionId: 15, name: 'Villa De Leiva', country: 'CO'},
          { id: '15879', regionId: 15, name: 'Viracacha', country: 'CO'},
          { id: '15897', regionId: 15, name: 'Zetaquira', country: 'CO'},
          { id: '17013', regionId: 17, name: 'Aguadas', country: 'CO'},
          { id: '17042', regionId: 17, name: 'Anserma', country: 'CO'},
          { id: '17050', regionId: 17, name: 'Aranzazu', country: 'CO'},
          { id: '17088', regionId: 17, name: 'Belalcazar', country: 'CO'},
          { id: '17174', regionId: 17, name: 'Chinchina', country: 'CO'},
          { id: '17272', regionId: 17, name: 'Filadelfia', country: 'CO'},
          { id: '17380', regionId: 17, name: 'La Dorada', country: 'CO'},
          { id: '17388', regionId: 17, name: 'La Merced', country: 'CO'},
          { id: '17001', regionId: 17, name: 'Manizales', country: 'CO'},
          { id: '17433', regionId: 17, name: 'Manzanares', country: 'CO'},
          { id: '17442', regionId: 17, name: 'Marmato', country: 'CO'},
          { id: '17444', regionId: 17, name: 'Marquetalia', country: 'CO'},
          { id: '17446', regionId: 17, name: 'Marulanda', country: 'CO'},
          { id: '17486', regionId: 17, name: 'Neira', country: 'CO'},
          { id: '17495', regionId: 17, name: 'Norcasia', country: 'CO'},
          { id: '17513', regionId: 17, name: 'Pacora', country: 'CO'},
          { id: '17524', regionId: 17, name: 'Palestina', country: 'CO'},
          { id: '17541', regionId: 17, name: 'Pensilvania', country: 'CO'},
          { id: '17614', regionId: 17, name: 'Riosucio', country: 'CO'},
          { id: '17616', regionId: 17, name: 'Risaralda', country: 'CO'},
          { id: '17653', regionId: 17, name: 'Salamina', country: 'CO'},
          { id: '17662', regionId: 17, name: 'Samana', country: 'CO'},
          { id: '17665', regionId: 17, name: 'San Jose', country: 'CO'},
          { id: '17777', regionId: 17, name: 'Supia', country: 'CO'},
          { id: '17867', regionId: 17, name: 'Victoria', country: 'CO'},
          { id: '17873', regionId: 17, name: 'Villamaria', country: 'CO'},
          { id: '17877', regionId: 17, name: 'Viterbo', country: 'CO'},
          { id: '18029', regionId: 18, name: 'Albania', country: 'CO'},
          { id: '18094', regionId: 18, name: 'Belen De Los Andaquies', country: 'CO'},
          { id: '18150', regionId: 18, name: 'Cartagena Del Chaira', country: 'CO'},
          { id: '18205', regionId: 18, name: 'Curillo', country: 'CO'},
          { id: '18247', regionId: 18, name: 'El Doncello', country: 'CO'},
          { id: '18256', regionId: 18, name: 'El Paujil', country: 'CO'},
          { id: '18001', regionId: 18, name: 'Florencia', country: 'CO'},
          { id: '18410', regionId: 18, name: 'La Montañita', country: 'CO'},
          { id: '18460', regionId: 18, name: 'Milan', country: 'CO'},
          { id: '18479', regionId: 18, name: 'Morelia', country: 'CO'},
          { id: '18592', regionId: 18, name: 'Puerto Rico', country: 'CO'},
          { id: '18753', regionId: 18, name: 'San  Vicente Del Caguan', country: 'CO'},
          { id: '18610', regionId: 18, name: 'San Jose De Fragua', country: 'CO'},
          { id: '18756', regionId: 18, name: 'Solano', country: 'CO'},
          { id: '18785', regionId: 18, name: 'Solita', country: 'CO'},
          { id: '18860', regionId: 18, name: 'Valparaiso', country: 'CO'},
          { id: '85010', regionId: 85, name: 'Aguazul', country: 'CO'},
          { id: '85015', regionId: 85, name: 'Chameza', country: 'CO'},
          { id: '85125', regionId: 85, name: 'Hato Corozal', country: 'CO'},
          { id: '85136', regionId: 85, name: 'La Salina', country: 'CO'},
          { id: '85139', regionId: 85, name: 'Mani', country: 'CO'},
          { id: '85162', regionId: 85, name: 'Monterrey', country: 'CO'},
          { id: '85225', regionId: 85, name: 'Nunchia', country: 'CO'},
          { id: '85230', regionId: 85, name: 'Orocue', country: 'CO'},
          { id: '85250', regionId: 85, name: 'Paz De Ariporo', country: 'CO'},
          { id: '85263', regionId: 85, name: 'Pore', country: 'CO'},
          { id: '85279', regionId: 85, name: 'Recetor', country: 'CO'},
          { id: '85300', regionId: 85, name: 'Sabanalarga', country: 'CO'},
          { id: '85315', regionId: 85, name: 'Sacama', country: 'CO'},
          { id: '85325', regionId: 85, name: 'San Luis De Palenque', country: 'CO'},
          { id: '85400', regionId: 85, name: 'Tamara', country: 'CO'},
          { id: '85410', regionId: 85, name: 'Tauramena', country: 'CO'},
          { id: '85430', regionId: 85, name: 'Trinidad', country: 'CO'},
          { id: '85440', regionId: 85, name: 'Villanueva', country: 'CO'},
          { id: '85001', regionId: 85, name: 'Yopal', country: 'CO'},
          { id: '19022', regionId: 19, name: 'Almaguer', country: 'CO'},
          { id: '19050', regionId: 19, name: 'Argelia', country: 'CO'},
          { id: '19075', regionId: 19, name: 'Balboa', country: 'CO'},
          { id: '19100', regionId: 19, name: 'Bolivar', country: 'CO'},
          { id: '19110', regionId: 19, name: 'Buenos Aires', country: 'CO'},
          { id: '19130', regionId: 19, name: 'Cajibio', country: 'CO'},
          { id: '19137', regionId: 19, name: 'Caldono', country: 'CO'},
          { id: '19142', regionId: 19, name: 'Caloto', country: 'CO'},
          { id: '19212', regionId: 19, name: 'Corinto', country: 'CO'},
          { id: '19256', regionId: 19, name: 'El Tambo', country: 'CO'},
          { id: '19290', regionId: 19, name: 'Florencia', country: 'CO'},
          { id: '19318', regionId: 19, name: 'Guapi', country: 'CO'},
          { id: '19355', regionId: 19, name: 'Inza', country: 'CO'},
          { id: '19364', regionId: 19, name: 'Jambalo', country: 'CO'},
          { id: '19392', regionId: 19, name: 'La Sierra', country: 'CO'},
          { id: '19397', regionId: 19, name: 'La Vega', country: 'CO'},
          { id: '19418', regionId: 19, name: 'Lopez (Micay)', country: 'CO'},
          { id: '19450', regionId: 19, name: 'Mercaderes', country: 'CO'},
          { id: '19455', regionId: 19, name: 'Miranda', country: 'CO'},
          { id: '19473', regionId: 19, name: 'Morales', country: 'CO'},
          { id: '19513', regionId: 19, name: 'Padilla', country: 'CO'},
          { id: '19517', regionId: 19, name: 'Paez (Belalcazar)', country: 'CO'},
          { id: '19532', regionId: 19, name: 'Patia (El Bordo)', country: 'CO'},
          { id: '19533', regionId: 19, name: 'Piamonte', country: 'CO'},
          { id: '19548', regionId: 19, name: 'Piendamo', country: 'CO'},
          { id: '19001', regionId: 19, name: 'Popayan', country: 'CO'},
          { id: '19573', regionId: 19, name: 'Puerto Tejada', country: 'CO'},
          { id: '19585', regionId: 19, name: 'Purace (Coconuco)', country: 'CO'},
          { id: '19622', regionId: 19, name: 'Rosas', country: 'CO'},
          { id: '19693', regionId: 19, name: 'San Sebastian', country: 'CO'},
          { id: '19701', regionId: 19, name: 'Santa Rosa', country: 'CO'},
          { id: '19698', regionId: 19, name: 'Santander De Quilichao', country: 'CO'},
          { id: '19743', regionId: 19, name: 'Silvia', country: 'CO'},
          { id: '19760', regionId: 19, name: 'Sotara (Paispamba)', country: 'CO'},
          { id: '19780', regionId: 19, name: 'Suarez', country: 'CO'},
          { id: '19807', regionId: 19, name: 'Timbio', country: 'CO'},
          { id: '19809', regionId: 19, name: 'Timbiqui', country: 'CO'},
          { id: '19821', regionId: 19, name: 'Toribio', country: 'CO'},
          { id: '19824', regionId: 19, name: 'Totoro', country: 'CO'},
          { id: '19845', regionId: 19, name: 'Villarica', country: 'CO'},
          { id: '20011', regionId: 20, name: 'Aguachica', country: 'CO'},
          { id: '20013', regionId: 20, name: 'Agustin Codazzi', country: 'CO'},
          { id: '20032', regionId: 20, name: 'Astrea', country: 'CO'},
          { id: '20045', regionId: 20, name: 'Becerril', country: 'CO'},
          { id: '20060', regionId: 20, name: 'Bosconia', country: 'CO'},
          { id: '20175', regionId: 20, name: 'Chimichagua', country: 'CO'},
          { id: '20178', regionId: 20, name: 'Chiriguana', country: 'CO'},
          { id: '20228', regionId: 20, name: 'Curumani', country: 'CO'},
          { id: '20238', regionId: 20, name: 'El Copey', country: 'CO'},
          { id: '20250', regionId: 20, name: 'El Paso', country: 'CO'},
          { id: '20295', regionId: 20, name: 'Gamarra', country: 'CO'},
          { id: '20310', regionId: 20, name: 'Gonzalez', country: 'CO'},
          { id: '20383', regionId: 20, name: 'La Gloria', country: 'CO'},
          { id: '20400', regionId: 20, name: 'La Jagua Ibirico', country: 'CO'},
          { id: '20621', regionId: 20, name: 'La Paz (Robles)', country: 'CO'},
          { id: '20443', regionId: 20, name: 'Manaure (Balcon Del Cesar)', country: 'CO'},
          { id: '20517', regionId: 20, name: 'Pailitas', country: 'CO'},
          { id: '20550', regionId: 20, name: 'Pelaya', country: 'CO'},
          { id: '20570', regionId: 20, name: 'Pueblo Bello', country: 'CO'},
          { id: '20614', regionId: 20, name: 'Rio De Oro', country: 'CO'},
          { id: '20710', regionId: 20, name: 'San Alberto', country: 'CO'},
          { id: '20750', regionId: 20, name: 'San Diego', country: 'CO'},
          { id: '20770', regionId: 20, name: 'San Martin', country: 'CO'},
          { id: '20787', regionId: 20, name: 'Tamalameque', country: 'CO'},
          { id: '20001', regionId: 20, name: 'Valledupar', country: 'CO'},
          { id: '27006', regionId: 27, name: 'Acandi', country: 'CO'},
          { id: '27025', regionId: 27, name: 'Alto Baudo (Pie De Pato)', country: 'CO'},
          { id: '27050', regionId: 27, name: 'Atrato', country: 'CO'},
          { id: '27073', regionId: 27, name: 'Bagado', country: 'CO'},
          { id: '27075', regionId: 27, name: 'Bahia Solano (Mutis)', country: 'CO'},
          { id: '27077', regionId: 27, name: 'Bajo Baudo (Pizarro)', country: 'CO'},
          { id: '27099', regionId: 27, name: 'Bojaya (Bellavista)', country: 'CO'},
          { id: '27135', regionId: 27, name: 'Canton De San Pablo(Managru)', country: 'CO'},
          { id: '27205', regionId: 27, name: 'Condoto', country: 'CO'},
          { id: '27245', regionId: 27, name: 'El Carmen De Atrato', country: 'CO'},
          { id: '27361', regionId: 27, name: 'Istmina', country: 'CO'},
          { id: '27372', regionId: 27, name: 'Jurado', country: 'CO'},
          { id: '27250', regionId: 27, name: 'Litoral Del Bajo San Juan (Santa Genoveva De Docordo)', country: 'CO'},
          { id: '27413', regionId: 27, name: 'Lloro', country: 'CO'},
          { id: '27425', regionId: 27, name: 'Medio Atrato', country: 'CO'},
          { id: '27430', regionId: 27, name: 'Medio Baudo', country: 'CO'},
          { id: '27491', regionId: 27, name: 'Novita', country: 'CO'},
          { id: '27495', regionId: 27, name: 'Nuqui', country: 'CO'},
          { id: '27001', regionId: 27, name: 'Quibdo (San Francisco De Quibdo)', country: 'CO'},
          { id: '27600', regionId: 27, name: 'Rioquito', country: 'CO'},
          { id: '27615', regionId: 27, name: 'Riosucio', country: 'CO'},
          { id: '27660', regionId: 27, name: 'San Jose Del Palmar', country: 'CO'},
          { id: '27745', regionId: 27, name: 'Sipi', country: 'CO'},
          { id: '27787', regionId: 27, name: 'Tado', country: 'CO'},
          { id: '27800', regionId: 27, name: 'Unguia', country: 'CO'},
          { id: '27810', regionId: 27, name: 'Union Panamericana', country: 'CO'},
          { id: '23068', regionId: 23, name: 'Ayapel', country: 'CO'},
          { id: '23079', regionId: 23, name: 'Buenavista', country: 'CO'},
          { id: '23090', regionId: 23, name: 'Canalete', country: 'CO'},
          { id: '23162', regionId: 23, name: 'Cerete', country: 'CO'},
          { id: '23168', regionId: 23, name: 'Chima', country: 'CO'},
          { id: '23182', regionId: 23, name: 'Chinu', country: 'CO'},
          { id: '23189', regionId: 23, name: 'Cienaga De Oro', country: 'CO'},
          { id: '23300', regionId: 23, name: 'Cotorra', country: 'CO'},
          { id: '23350', regionId: 23, name: 'La Apartada', country: 'CO'},
          { id: '23417', regionId: 23, name: 'Lorica', country: 'CO'},
          { id: '23419', regionId: 23, name: 'Los Cordobas', country: 'CO'},
          { id: '23464', regionId: 23, name: 'Momil', country: 'CO'},
          { id: '23500', regionId: 23, name: 'Moñitos', country: 'CO'},
          { id: '23466', regionId: 23, name: 'Montelibano', country: 'CO'},
          { id: '23001', regionId: 23, name: 'Monteria', country: 'CO'},
          { id: '23555', regionId: 23, name: 'Planeta Rica', country: 'CO'},
          { id: '23570', regionId: 23, name: 'Pueblo Nuevo', country: 'CO'},
          { id: '23574', regionId: 23, name: 'Puerto Escondido', country: 'CO'},
          { id: '23580', regionId: 23, name: 'Puerto Libertador', country: 'CO'},
          { id: '23586', regionId: 23, name: 'Purisima', country: 'CO'},
          { id: '23660', regionId: 23, name: 'Sahagun', country: 'CO'},
          { id: '23670', regionId: 23, name: 'San Andres Sotavento', country: 'CO'},
          { id: '23672', regionId: 23, name: 'San Antero', country: 'CO'},
          { id: '23675', regionId: 23, name: 'San Bernardo Del Viento', country: 'CO'},
          { id: '23678', regionId: 23, name: 'San Carlos', country: 'CO'},
          { id: '23686', regionId: 23, name: 'San Pelayo', country: 'CO'},
          { id: '23807', regionId: 23, name: 'Tierralta', country: 'CO'},
          { id: '23855', regionId: 23, name: 'Valencia', country: 'CO'},
          { id: '25001', regionId: 25, name: 'Agua De Dios', country: 'CO'},
          { id: '25019', regionId: 25, name: 'Alban', country: 'CO'},
          { id: '25035', regionId: 25, name: 'Anapoima', country: 'CO'},
          { id: '25040', regionId: 25, name: 'Anolaima', country: 'CO'},
          { id: '25599', regionId: 25, name: 'Apulo (Rafael Reyes)', country: 'CO'},
          { id: '25053', regionId: 25, name: 'Arbelaez', country: 'CO'},
          { id: '25086', regionId: 25, name: 'Beltran', country: 'CO'},
          { id: '25095', regionId: 25, name: 'Bituima', country: 'CO'},
          { id: '25099', regionId: 25, name: 'Bojaca', country: 'CO'},
          { id: '25120', regionId: 25, name: 'Cabrera', country: 'CO'},
          { id: '25123', regionId: 25, name: 'Cachipay', country: 'CO'},
          { id: '25126', regionId: 25, name: 'Cajica', country: 'CO'},
          { id: '25148', regionId: 25, name: 'Caparrapi', country: 'CO'},
          { id: '25151', regionId: 25, name: 'Caqueza', country: 'CO'},
          { id: '25154', regionId: 25, name: 'Carmen De Carupa', country: 'CO'},
          { id: '25168', regionId: 25, name: 'Chaguani', country: 'CO'},
          { id: '25175', regionId: 25, name: 'Chia', country: 'CO'},
          { id: '25178', regionId: 25, name: 'Chipaque', country: 'CO'},
          { id: '25181', regionId: 25, name: 'Choachi', country: 'CO'},
          { id: '25183', regionId: 25, name: 'Choconta', country: 'CO'},
          { id: '25200', regionId: 25, name: 'Cogua', country: 'CO'},
          { id: '25214', regionId: 25, name: 'Cota', country: 'CO'},
          { id: '25224', regionId: 25, name: 'Cucunuba', country: 'CO'},
          { id: '25245', regionId: 25, name: 'El Colegio', country: 'CO'},
          { id: '25258', regionId: 25, name: 'El Peñon', country: 'CO'},
          { id: '25260', regionId: 25, name: 'El Rosal', country: 'CO'},
          { id: '25269', regionId: 25, name: 'Facatativa', country: 'CO'},
          { id: '25279', regionId: 25, name: 'Fomeque', country: 'CO'},
          { id: '25281', regionId: 25, name: 'Fosca', country: 'CO'},
          { id: '25286', regionId: 25, name: 'Funza', country: 'CO'},
          { id: '25288', regionId: 25, name: 'Fuquene', country: 'CO'},
          { id: '25290', regionId: 25, name: 'Fusagasuga', country: 'CO'},
          { id: '25293', regionId: 25, name: 'Gachala', country: 'CO'},
          { id: '25295', regionId: 25, name: 'Gachancipa', country: 'CO'},
          { id: '25297', regionId: 25, name: 'Gacheta', country: 'CO'},
          { id: '25299', regionId: 25, name: 'Gama', country: 'CO'},
          { id: '25307', regionId: 25, name: 'Girardot', country: 'CO'},
          { id: '25312', regionId: 25, name: 'Granada', country: 'CO'},
          { id: '25317', regionId: 25, name: 'Guacheta', country: 'CO'},
          { id: '25320', regionId: 25, name: 'Guaduas', country: 'CO'},
          { id: '25322', regionId: 25, name: 'Guasca', country: 'CO'},
          { id: '25324', regionId: 25, name: 'Guataqui', country: 'CO'},
          { id: '25326', regionId: 25, name: 'Guatavita', country: 'CO'},
          { id: '25328', regionId: 25, name: 'Guayabal De Siquima', country: 'CO'},
          { id: '25335', regionId: 25, name: 'Guayabetal', country: 'CO'},
          { id: '25339', regionId: 25, name: 'Gutierrez', country: 'CO'},
          { id: '25368', regionId: 25, name: 'Jerusalen', country: 'CO'},
          { id: '25372', regionId: 25, name: 'Junin', country: 'CO'},
          { id: '25377', regionId: 25, name: 'La Calera', country: 'CO'},
          { id: '25386', regionId: 25, name: 'La Mesa', country: 'CO'},
          { id: '25394', regionId: 25, name: 'La Palma', country: 'CO'},
          { id: '25398', regionId: 25, name: 'La Peña', country: 'CO'},
          { id: '25402', regionId: 25, name: 'La Vega', country: 'CO'},
          { id: '25407', regionId: 25, name: 'Lenguazaque', country: 'CO'},
          { id: '25426', regionId: 25, name: 'Macheta', country: 'CO'},
          { id: '25430', regionId: 25, name: 'Madrid', country: 'CO'},
          { id: '25436', regionId: 25, name: 'Manta', country: 'CO'},
          { id: '25438', regionId: 25, name: 'Medina', country: 'CO'},
          { id: '25473', regionId: 25, name: 'Mosquera', country: 'CO'},
          { id: '25483', regionId: 25, name: 'Nariño', country: 'CO'},
          { id: '25486', regionId: 25, name: 'Nemocon', country: 'CO'},
          { id: '25488', regionId: 25, name: 'Nilo', country: 'CO'},
          { id: '25489', regionId: 25, name: 'Nimaima', country: 'CO'},
          { id: '25491', regionId: 25, name: 'Nocaima', country: 'CO'},
          { id: '25513', regionId: 25, name: 'Pacho', country: 'CO'},
          { id: '25518', regionId: 25, name: 'Paime', country: 'CO'},
          { id: '25524', regionId: 25, name: 'Pandi', country: 'CO'},
          { id: '25530', regionId: 25, name: 'Paratebueno', country: 'CO'},
          { id: '25535', regionId: 25, name: 'Pasca', country: 'CO'},
          { id: '25572', regionId: 25, name: 'Puerto Salgar', country: 'CO'},
          { id: '25580', regionId: 25, name: 'Puli', country: 'CO'},
          { id: '25592', regionId: 25, name: 'Quebradanegra', country: 'CO'},
          { id: '25594', regionId: 25, name: 'Quetame', country: 'CO'},
          { id: '25596', regionId: 25, name: 'Quipile', country: 'CO'},
          { id: '25612', regionId: 25, name: 'Ricaurte', country: 'CO'},
          { id: '25645', regionId: 25, name: 'San  Antonio Del Tequendama', country: 'CO'},
          { id: '25649', regionId: 25, name: 'San Bernardo', country: 'CO'},
          { id: '25653', regionId: 25, name: 'San Cayetano', country: 'CO'},
          { id: '25658', regionId: 25, name: 'San Francisco', country: 'CO'},
          { id: '25662', regionId: 25, name: 'San Juan De Rioseco', country: 'CO'},
          { id: '25718', regionId: 25, name: 'Sasaima', country: 'CO'},
          { id: '25736', regionId: 25, name: 'Sesquile', country: 'CO'},
          { id: '25740', regionId: 25, name: 'Sibate', country: 'CO'},
          { id: '25743', regionId: 25, name: 'Silvania', country: 'CO'},
          { id: '25745', regionId: 25, name: 'Simijaca', country: 'CO'},
          { id: '25754', regionId: 25, name: 'Soacha', country: 'CO'},
          { id: '25758', regionId: 25, name: 'Sopo', country: 'CO'},
          { id: '25769', regionId: 25, name: 'Subachoque', country: 'CO'},
          { id: '25772', regionId: 25, name: 'Suesca', country: 'CO'},
          { id: '25777', regionId: 25, name: 'Supata', country: 'CO'},
          { id: '25779', regionId: 25, name: 'Susa', country: 'CO'},
          { id: '25781', regionId: 25, name: 'Sutatausa', country: 'CO'},
          { id: '25785', regionId: 25, name: 'Tabio', country: 'CO'},
          { id: '25793', regionId: 25, name: 'Tausa', country: 'CO'},
          { id: '25797', regionId: 25, name: 'Tena', country: 'CO'},
          { id: '25799', regionId: 25, name: 'Tenjo', country: 'CO'},
          { id: '25805', regionId: 25, name: 'Tibacuy', country: 'CO'},
          { id: '25807', regionId: 25, name: 'Tibirita', country: 'CO'},
          { id: '25815', regionId: 25, name: 'Tocaima', country: 'CO'},
          { id: '25817', regionId: 25, name: 'Tocancipa', country: 'CO'},
          { id: '25823', regionId: 25, name: 'Topaipi', country: 'CO'},
          { id: '25839', regionId: 25, name: 'Ubala', country: 'CO'},
          { id: '25841', regionId: 25, name: 'Ubaque', country: 'CO'},
          { id: '25843', regionId: 25, name: 'Ubate', country: 'CO'},
          { id: '25845', regionId: 25, name: 'Une', country: 'CO'},
          { id: '25851', regionId: 25, name: 'Utica', country: 'CO'},
          { id: '25506', regionId: 25, name: 'Venecia (Ospina Perez)', country: 'CO'},
          { id: '25862', regionId: 25, name: 'Vergara', country: 'CO'},
          { id: '25867', regionId: 25, name: 'Viani', country: 'CO'},
          { id: '25871', regionId: 25, name: 'Villagomez', country: 'CO'},
          { id: '25873', regionId: 25, name: 'Villapinzon', country: 'CO'},
          { id: '25875', regionId: 25, name: 'Villeta', country: 'CO'},
          { id: '25878', regionId: 25, name: 'Viota', country: 'CO'},
          { id: '25885', regionId: 25, name: 'Yacopi', country: 'CO'},
          { id: '25898', regionId: 25, name: 'Zipacon', country: 'CO'},
          { id: '25899', regionId: 25, name: 'Zipaquira', country: 'CO'},
          { id: '94343', regionId: 94, name: 'Barranco Minas', country: 'CO'},
          { id: '94886', regionId: 94, name: 'Cacahual', country: 'CO'},
          { id: '94885', regionId: 94, name: 'La Guadalupe', country: 'CO'},
          { id: '94888', regionId: 94, name: 'Morichal (Morichal Nuevo)', country: 'CO'},
          { id: '94887', regionId: 94, name: 'Pana Pana (Campo Alegre)', country: 'CO'},
          { id: '94884', regionId: 94, name: 'Puerto Colombia', country: 'CO'},
          { id: '94001', regionId: 94, name: 'Puerto Inirida', country: 'CO'},
          { id: '94883', regionId: 94, name: 'San Felipe', country: 'CO'},
          { id: '95015', regionId: 95, name: 'Calamar', country: 'CO'},
          { id: '95025', regionId: 95, name: 'El Retorno', country: 'CO'},
          { id: '95200', regionId: 95, name: 'Miraflores', country: 'CO'},
          { id: '95001', regionId: 95, name: 'San Jose Del Guaviare', country: 'CO'},
          { id: '41006', regionId: 41, name: 'Acevedo', country: 'CO'},
          { id: '41013', regionId: 41, name: 'Agrado', country: 'CO'},
          { id: '41016', regionId: 41, name: 'Aipe', country: 'CO'},
          { id: '41020', regionId: 41, name: 'Algeciras', country: 'CO'},
          { id: '41026', regionId: 41, name: 'Altamira', country: 'CO'},
          { id: '41078', regionId: 41, name: 'Baraya', country: 'CO'},
          { id: '41132', regionId: 41, name: 'Campoalegre', country: 'CO'},
          { id: '41206', regionId: 41, name: 'Colombia', country: 'CO'},
          { id: '41244', regionId: 41, name: 'Elias', country: 'CO'},
          { id: '41298', regionId: 41, name: 'Garzon', country: 'CO'},
          { id: '41306', regionId: 41, name: 'Gigante', country: 'CO'},
          { id: '41319', regionId: 41, name: 'Guadalupe', country: 'CO'},
          { id: '41349', regionId: 41, name: 'Hobo', country: 'CO'},
          { id: '41357', regionId: 41, name: 'Iquira', country: 'CO'},
          { id: '41359', regionId: 41, name: 'Isnos (San Jose De Isnos)', country: 'CO'},
          { id: '41378', regionId: 41, name: 'La Argentina', country: 'CO'},
          { id: '41396', regionId: 41, name: 'La Plata', country: 'CO'},
          { id: '41483', regionId: 41, name: 'Nataga', country: 'CO'},
          { id: '41001', regionId: 41, name: 'Neiva', country: 'CO'},
          { id: '41503', regionId: 41, name: 'Oporapa', country: 'CO'},
          { id: '41518', regionId: 41, name: 'Paicol', country: 'CO'},
          { id: '41524', regionId: 41, name: 'Palermo', country: 'CO'},
          { id: '41530', regionId: 41, name: 'Palestina', country: 'CO'},
          { id: '41548', regionId: 41, name: 'Pital', country: 'CO'},
          { id: '41551', regionId: 41, name: 'Pitalito', country: 'CO'},
          { id: '41615', regionId: 41, name: 'Rivera', country: 'CO'},
          { id: '41660', regionId: 41, name: 'Saladoblanco', country: 'CO'},
          { id: '41668', regionId: 41, name: 'San Agustin', country: 'CO'},
          { id: '41676', regionId: 41, name: 'Santa Maria', country: 'CO'},
          { id: '41770', regionId: 41, name: 'Suaza', country: 'CO'},
          { id: '41791', regionId: 41, name: 'Tarqui', country: 'CO'},
          { id: '41799', regionId: 41, name: 'Tello', country: 'CO'},
          { id: '41801', regionId: 41, name: 'Teruel', country: 'CO'},
          { id: '41797', regionId: 41, name: 'Tesalia', country: 'CO'},
          { id: '41807', regionId: 41, name: 'Timana', country: 'CO'},
          { id: '41872', regionId: 41, name: 'Villavieja', country: 'CO'},
          { id: '41885', regionId: 41, name: 'Yaguara', country: 'CO'},
          { id: '44078', regionId: 44, name: 'Barrancas', country: 'CO'},
          { id: '44090', regionId: 44, name: 'Dibulla', country: 'CO'},
          { id: '44098', regionId: 44, name: 'Distraccion', country: 'CO'},
          { id: '44110', regionId: 44, name: 'El Molino', country: 'CO'},
          { id: '44279', regionId: 44, name: 'Fonseca', country: 'CO'},
          { id: '44378', regionId: 44, name: 'Hatonuevo', country: 'CO'},
          { id: '44420', regionId: 44, name: 'La Jagua Del Pilar', country: 'CO'},
          { id: '44430', regionId: 44, name: 'Maicao', country: 'CO'},
          { id: '44560', regionId: 44, name: 'Manaure', country: 'CO'},
          { id: '44001', regionId: 44, name: 'Riohacha', country: 'CO'},
          { id: '44650', regionId: 44, name: 'San Juan Del Cesar', country: 'CO'},
          { id: '44847', regionId: 44, name: 'Uribia', country: 'CO'},
          { id: '44855', regionId: 44, name: 'Urumita', country: 'CO'},
          { id: '44874', regionId: 44, name: 'Villanueva', country: 'CO'},
          { id: '47030', regionId: 47, name: 'Algarrobo', country: 'CO'},
          { id: '47053', regionId: 47, name: 'Aracataca', country: 'CO'},
          { id: '47058', regionId: 47, name: 'Ariguani (El Dificil)', country: 'CO'},
          { id: '47161', regionId: 47, name: 'Cerro San Antonio', country: 'CO'},
          { id: '47170', regionId: 47, name: 'Chivolo', country: 'CO'},
          { id: '47189', regionId: 47, name: 'Cienaga', country: 'CO'},
          { id: '47205', regionId: 47, name: 'Concordia', country: 'CO'},
          { id: '47245', regionId: 47, name: 'El Banco', country: 'CO'},
          { id: '47258', regionId: 47, name: 'El Piñon', country: 'CO'},
          { id: '47268', regionId: 47, name: 'El Reten', country: 'CO'},
          { id: '47288', regionId: 47, name: 'Fundacion', country: 'CO'},
          { id: '47318', regionId: 47, name: 'Guamal', country: 'CO'},
          { id: '47541', regionId: 47, name: 'Pedraza', country: 'CO'},
          { id: '47545', regionId: 47, name: 'Pijiño Del Carmen (Pijiño)', country: 'CO'},
          { id: '47551', regionId: 47, name: 'Pivijay', country: 'CO'},
          { id: '47555', regionId: 47, name: 'Plato', country: 'CO'},
          { id: '47570', regionId: 47, name: 'Puebloviejo', country: 'CO'},
          { id: '47605', regionId: 47, name: 'Remolino', country: 'CO'},
          { id: '47660', regionId: 47, name: 'Sabanas De San Angel', country: 'CO'},
          { id: '47675', regionId: 47, name: 'Salamina', country: 'CO'},
          { id: '47692', regionId: 47, name: 'San Sebastian De Buenavista', country: 'CO'},
          { id: '47703', regionId: 47, name: 'San Zenon', country: 'CO'},
          { id: '47707', regionId: 47, name: 'Santa Ana', country: 'CO'},
          { id: '47001', regionId: 47, name: 'Santa Marta (Distrito Turistico, Cultural E Historicode Santa Marta)', country: 'CO'},
          { id: '47745', regionId: 47, name: 'Sitionuevo', country: 'CO'},
          { id: '47798', regionId: 47, name: 'Tenerife', country: 'CO'},
          { id: '50006', regionId: 50, name: 'Acacias', country: 'CO'},
          { id: '50110', regionId: 50, name: 'Barranca De Upia', country: 'CO'},
          { id: '50124', regionId: 50, name: 'Cabuyaro', country: 'CO'},
          { id: '50150', regionId: 50, name: 'Castilla La Nueva', country: 'CO'},
          { id: '50226', regionId: 50, name: 'Cumaral', country: 'CO'},
          { id: '50245', regionId: 50, name: 'El Calvario', country: 'CO'},
          { id: '50251', regionId: 50, name: 'El Castillo', country: 'CO'},
          { id: '50270', regionId: 50, name: 'El Dorado', country: 'CO'},
          { id: '50287', regionId: 50, name: 'Fuente De Oro', country: 'CO'},
          { id: '50313', regionId: 50, name: 'Granada', country: 'CO'},
          { id: '50318', regionId: 50, name: 'Guamal', country: 'CO'},
          { id: '50350', regionId: 50, name: 'La Macarena', country: 'CO'},
          { id: '50370', regionId: 50, name: 'La Uribe', country: 'CO'},
          { id: '50400', regionId: 50, name: 'Lejanias', country: 'CO'},
          { id: '50325', regionId: 50, name: 'Mapiripan', country: 'CO'},
          { id: '50330', regionId: 50, name: 'Mesetas', country: 'CO'},
          { id: '50450', regionId: 50, name: 'Puerto Concordia', country: 'CO'},
          { id: '50568', regionId: 50, name: 'Puerto Gaitan', country: 'CO'},
          { id: '50577', regionId: 50, name: 'Puerto Lleras', country: 'CO'},
          { id: '50573', regionId: 50, name: 'Puerto Lopez', country: 'CO'},
          { id: '50590', regionId: 50, name: 'Puerto Rico', country: 'CO'},
          { id: '50606', regionId: 50, name: 'Restrepo', country: 'CO'},
          { id: '50683', regionId: 50, name: 'San  Juan De Arama', country: 'CO'},
          { id: '50680', regionId: 50, name: 'San Carlos De Guaroa', country: 'CO'},
          { id: '50686', regionId: 50, name: 'San Juanito', country: 'CO'},
          { id: '50223', regionId: 50, name: 'San Luis De Cubarral', country: 'CO'},
          { id: '50689', regionId: 50, name: 'San Martin', country: 'CO'},
          { id: '50001', regionId: 50, name: 'Villavicencio', country: 'CO'},
          { id: '50711', regionId: 50, name: 'Vistahermosa', country: 'CO'},
          { id: '52019', regionId: 52, name: 'Alban (San Jose)', country: 'CO'},
          { id: '52022', regionId: 52, name: 'Aldana', country: 'CO'},
          { id: '52036', regionId: 52, name: 'Ancuya', country: 'CO'},
          { id: '52051', regionId: 52, name: 'Arboleda (Berruecos)', country: 'CO'},
          { id: '52079', regionId: 52, name: 'Barbacoas', country: 'CO'},
          { id: '52083', regionId: 52, name: 'Belen', country: 'CO'},
          { id: '52110', regionId: 52, name: 'Buesaco', country: 'CO'},
          { id: '52240', regionId: 52, name: 'Chachagui', country: 'CO'},
          { id: '52203', regionId: 52, name: 'Colon (Genova)', country: 'CO'},
          { id: '52207', regionId: 52, name: 'Consaca', country: 'CO'},
          { id: '52210', regionId: 52, name: 'Contadero', country: 'CO'},
          { id: '52215', regionId: 52, name: 'Cordoba', country: 'CO'},
          { id: '52224', regionId: 52, name: 'Cuaspud (Carlosama)', country: 'CO'},
          { id: '52227', regionId: 52, name: 'Cumbal', country: 'CO'},
          { id: '52233', regionId: 52, name: 'Cumbitara', country: 'CO'},
          { id: '52250', regionId: 52, name: 'El Charco', country: 'CO'},
          { id: '52254', regionId: 52, name: 'El Peñol', country: 'CO'},
          { id: '52256', regionId: 52, name: 'El Rosario', country: 'CO'},
          { id: '52258', regionId: 52, name: 'El Tablon', country: 'CO'},
          { id: '52260', regionId: 52, name: 'El Tambo', country: 'CO'},
          { id: '52520', regionId: 52, name: 'Francisco Pizarro (Salahonda)', country: 'CO'},
          { id: '52287', regionId: 52, name: 'Funes', country: 'CO'},
          { id: '52317', regionId: 52, name: 'Guachucal', country: 'CO'},
          { id: '52320', regionId: 52, name: 'Guaitarilla', country: 'CO'},
          { id: '52323', regionId: 52, name: 'Gualmatan', country: 'CO'},
          { id: '52352', regionId: 52, name: 'Iles', country: 'CO'},
          { id: '52354', regionId: 52, name: 'Imues', country: 'CO'},
          { id: '52356', regionId: 52, name: 'Ipiales', country: 'CO'},
          { id: '52378', regionId: 52, name: 'La Cruz', country: 'CO'},
          { id: '52381', regionId: 52, name: 'La Florida', country: 'CO'},
          { id: '52385', regionId: 52, name: 'La Llanada', country: 'CO'},
          { id: '52390', regionId: 52, name: 'La Tola', country: 'CO'},
          { id: '52399', regionId: 52, name: 'La Union', country: 'CO'},
          { id: '52405', regionId: 52, name: 'Leiva', country: 'CO'},
          { id: '52411', regionId: 52, name: 'Linares', country: 'CO'},
          { id: '52418', regionId: 52, name: 'Los Andes (Sotomayor)', country: 'CO'},
          { id: '52427', regionId: 52, name: 'Magui (Payan)', country: 'CO'},
          { id: '52435', regionId: 52, name: 'Mallama (Piedrancha)', country: 'CO'},
          { id: '52473', regionId: 52, name: 'Mosquera', country: 'CO'},
          { id: '52490', regionId: 52, name: 'Olaya Herrera (Bocas De Satinga)', country: 'CO'},
          { id: '52506', regionId: 52, name: 'Ospina', country: 'CO'},
          { id: '52001', regionId: 52, name: 'Pasto (San Juan De Pasto)', country: 'CO'},
          { id: '52540', regionId: 52, name: 'Policarpa', country: 'CO'},
          { id: '52560', regionId: 52, name: 'Potosi', country: 'CO'},
          { id: '52565', regionId: 52, name: 'Providencia', country: 'CO'},
          { id: '52573', regionId: 52, name: 'Puerres', country: 'CO'},
          { id: '52585', regionId: 52, name: 'Pupiales', country: 'CO'},
          { id: '52612', regionId: 52, name: 'Ricaurte', country: 'CO'},
          { id: '52621', regionId: 52, name: 'Roberto Payan (San Jose)', country: 'CO'},
          { id: '52678', regionId: 52, name: 'Samaniego', country: 'CO'},
          { id: '52685', regionId: 52, name: 'San Bernardo', country: 'CO'},
          { id: '52687', regionId: 52, name: 'San Lorenzo', country: 'CO'},
          { id: '52693', regionId: 52, name: 'San Pablo', country: 'CO'},
          { id: '52694', regionId: 52, name: 'San Pedro De Cartago', country: 'CO'},
          { id: '52683', regionId: 52, name: 'Sandona', country: 'CO'},
          { id: '52696', regionId: 52, name: 'Santa Barbara (Iscuande)', country: 'CO'},
          { id: '52699', regionId: 52, name: 'Santa Cruz (Guachaves)', country: 'CO'},
          { id: '52720', regionId: 52, name: 'Sapuyes', country: 'CO'},
          { id: '52786', regionId: 52, name: 'Taminango', country: 'CO'},
          { id: '52788', regionId: 52, name: 'Tangua', country: 'CO'},
          { id: '52835', regionId: 52, name: 'Tumaco', country: 'CO'},
          { id: '52838', regionId: 52, name: 'Tuquerres', country: 'CO'},
          { id: '52885', regionId: 52, name: 'Yacuanquer', country: 'CO'},
          { id: '54003', regionId: 54, name: 'Abrego', country: 'CO'},
          { id: '54051', regionId: 54, name: 'Arboledas', country: 'CO'},
          { id: '54099', regionId: 54, name: 'Bochalema', country: 'CO'},
          { id: '54109', regionId: 54, name: 'Bucarasica', country: 'CO'},
          { id: '54128', regionId: 54, name: 'Cachira', country: 'CO'},
          { id: '54125', regionId: 54, name: 'Cacota', country: 'CO'},
          { id: '54172', regionId: 54, name: 'Chinacota', country: 'CO'},
          { id: '54174', regionId: 54, name: 'Chitaga', country: 'CO'},
          { id: '54206', regionId: 54, name: 'Convencion', country: 'CO'},
          { id: '54001', regionId: 54, name: 'Cucuta', country: 'CO'},
          { id: '54223', regionId: 54, name: 'Cucutilla', country: 'CO'},
          { id: '54239', regionId: 54, name: 'Durania', country: 'CO'},
          { id: '54245', regionId: 54, name: 'El Carmen', country: 'CO'},
          { id: '54250', regionId: 54, name: 'El Tarra', country: 'CO'},
          { id: '54261', regionId: 54, name: 'El Zulia', country: 'CO'},
          { id: '54313', regionId: 54, name: 'Gramalote', country: 'CO'},
          { id: '54344', regionId: 54, name: 'Hacari', country: 'CO'},
          { id: '54347', regionId: 54, name: 'Herran', country: 'CO'},
          { id: '54385', regionId: 54, name: 'La Esperanza', country: 'CO'},
          { id: '54398', regionId: 54, name: 'La Playa', country: 'CO'},
          { id: '54377', regionId: 54, name: 'Labateca', country: 'CO'},
          { id: '54405', regionId: 54, name: 'Los Patios', country: 'CO'},
          { id: '54418', regionId: 54, name: 'Lourdes', country: 'CO'},
          { id: '54480', regionId: 54, name: 'Mutiscua', country: 'CO'},
          { id: '54498', regionId: 54, name: 'Ocaña', country: 'CO'},
          { id: '54518', regionId: 54, name: 'Pamplona', country: 'CO'},
          { id: '54520', regionId: 54, name: 'Pamplonita', country: 'CO'},
          { id: '54553', regionId: 54, name: 'Puerto Santander', country: 'CO'},
          { id: '54599', regionId: 54, name: 'Ragonvalia', country: 'CO'},
          { id: '54660', regionId: 54, name: 'Salazar', country: 'CO'},
          { id: '54670', regionId: 54, name: 'San Calixto', country: 'CO'},
          { id: '54673', regionId: 54, name: 'San Cayetano', country: 'CO'},
          { id: '54680', regionId: 54, name: 'Santiago', country: 'CO'},
          { id: '54720', regionId: 54, name: 'Sardinata', country: 'CO'},
          { id: '54743', regionId: 54, name: 'Silos', country: 'CO'},
          { id: '54800', regionId: 54, name: 'Teorama', country: 'CO'},
          { id: '54810', regionId: 54, name: 'Tibu', country: 'CO'},
          { id: '54820', regionId: 54, name: 'Toledo', country: 'CO'},
          { id: '54874', regionId: 54, name: 'Villa Del Rosario', country: 'CO'},
          { id: '54871', regionId: 54, name: 'Villacaro', country: 'CO'},
          { id: '86219', regionId: 86, name: 'Colon', country: 'CO'},
          { id: '86865', regionId: 86, name: 'La Hormiga (Valle Del Guamuez)', country: 'CO'},
          { id: '86001', regionId: 86, name: 'Mocoa', country: 'CO'},
          { id: '86320', regionId: 86, name: 'Orito', country: 'CO'},
          { id: '86568', regionId: 86, name: 'Puerto Asis', country: 'CO'},
          { id: '86569', regionId: 86, name: 'Puerto Caicedo', country: 'CO'},
          { id: '86571', regionId: 86, name: 'Puerto Guzman', country: 'CO'},
          { id: '86573', regionId: 86, name: 'Puerto Leguizamo', country: 'CO'},
          { id: '86755', regionId: 86, name: 'San Francisco', country: 'CO'},
          { id: '86757', regionId: 86, name: 'San Miguel (La Dorada)', country: 'CO'},
          { id: '86760', regionId: 86, name: 'Santiago', country: 'CO'},
          { id: '86749', regionId: 86, name: 'Sibundoy', country: 'CO'},
          { id: '86885', regionId: 86, name: 'Villagarzon', country: 'CO'},
          { id: '63001', regionId: 63, name: 'Armenia', country: 'CO'},
          { id: '63111', regionId: 63, name: 'Buenavista', country: 'CO'},
          { id: '63130', regionId: 63, name: 'Calarca', country: 'CO'},
          { id: '63190', regionId: 63, name: 'Circasia', country: 'CO'},
          { id: '63212', regionId: 63, name: 'Cordoba', country: 'CO'},
          { id: '63272', regionId: 63, name: 'Filandia', country: 'CO'},
          { id: '63302', regionId: 63, name: 'Genova', country: 'CO'},
          { id: '63401', regionId: 63, name: 'La Tebaida', country: 'CO'},
          { id: '63470', regionId: 63, name: 'Montenegro', country: 'CO'},
          { id: '63548', regionId: 63, name: 'Pijao', country: 'CO'},
          { id: '63594', regionId: 63, name: 'Quimbaya', country: 'CO'},
          { id: '63690', regionId: 63, name: 'Salento', country: 'CO'},
          { id: '66045', regionId: 66, name: 'Apia', country: 'CO'},
          { id: '66075', regionId: 66, name: 'Balboa', country: 'CO'},
          { id: '66088', regionId: 66, name: 'Belen De Umbria', country: 'CO'},
          { id: '66170', regionId: 66, name: 'Dos Quebradas', country: 'CO'},
          { id: '66318', regionId: 66, name: 'Guatica', country: 'CO'},
          { id: '66383', regionId: 66, name: 'La Celia', country: 'CO'},
          { id: '66400', regionId: 66, name: 'La Virginia', country: 'CO'},
          { id: '66440', regionId: 66, name: 'Marsella', country: 'CO'},
          { id: '66456', regionId: 66, name: 'Mistrato', country: 'CO'},
          { id: '66001', regionId: 66, name: 'Pereira', country: 'CO'},
          { id: '66572', regionId: 66, name: 'Pueblo Rico', country: 'CO'},
          { id: '66594', regionId: 66, name: 'Quinchia', country: 'CO'},
          { id: '66682', regionId: 66, name: 'Santa Rosa De Cabal', country: 'CO'},
          { id: '66687', regionId: 66, name: 'Santuario', country: 'CO'},
          { id: '88564', regionId: 88, name: 'Providencia', country: 'CO'},
          { id: '88001', regionId: 88, name: 'San Andres', country: 'CO'},
          { id: '68013', regionId: 68, name: 'Aguada', country: 'CO'},
          { id: '68020', regionId: 68, name: 'Albania', country: 'CO'},
          { id: '68051', regionId: 68, name: 'Aratoca', country: 'CO'},
          { id: '68077', regionId: 68, name: 'Barbosa', country: 'CO'},
          { id: '68079', regionId: 68, name: 'Barichara', country: 'CO'},
          { id: '68081', regionId: 68, name: 'Barrancabermeja', country: 'CO'},
          { id: '68092', regionId: 68, name: 'Betulia', country: 'CO'},
          { id: '68101', regionId: 68, name: 'Bolivar', country: 'CO'},
          { id: '68001', regionId: 68, name: 'Bucaramanga', country: 'CO'},
          { id: '68121', regionId: 68, name: 'Cabrera', country: 'CO'},
          { id: '68132', regionId: 68, name: 'California', country: 'CO'},
          { id: '68147', regionId: 68, name: 'Capitanejo', country: 'CO'},
          { id: '68152', regionId: 68, name: 'Carcasi', country: 'CO'},
          { id: '68160', regionId: 68, name: 'Cepita', country: 'CO'},
          { id: '68162', regionId: 68, name: 'Cerrito', country: 'CO'},
          { id: '68167', regionId: 68, name: 'Charala', country: 'CO'},
          { id: '68169', regionId: 68, name: 'Charta', country: 'CO'},
          { id: '68176', regionId: 68, name: 'Chima', country: 'CO'},
          { id: '68179', regionId: 68, name: 'Chipata', country: 'CO'},
          { id: '68190', regionId: 68, name: 'Cimitarra', country: 'CO'},
          { id: '68207', regionId: 68, name: 'Concepcion', country: 'CO'},
          { id: '68209', regionId: 68, name: 'Confines', country: 'CO'},
          { id: '68211', regionId: 68, name: 'Contratacion', country: 'CO'},
          { id: '68217', regionId: 68, name: 'Coromoro', country: 'CO'},
          { id: '68229', regionId: 68, name: 'Curiti', country: 'CO'},
          { id: '68235', regionId: 68, name: 'El Carmen De Chucury', country: 'CO'},
          { id: '68245', regionId: 68, name: 'El Guacamayo', country: 'CO'},
          { id: '68250', regionId: 68, name: 'El Peñon', country: 'CO'},
          { id: '68255', regionId: 68, name: 'El Playon', country: 'CO'},
          { id: '68264', regionId: 68, name: 'Encino', country: 'CO'},
          { id: '68266', regionId: 68, name: 'Enciso', country: 'CO'},
          { id: '68271', regionId: 68, name: 'Florian', country: 'CO'},
          { id: '68276', regionId: 68, name: 'Floridablanca', country: 'CO'},
          { id: '68296', regionId: 68, name: 'Galan', country: 'CO'},
          { id: '68298', regionId: 68, name: 'Gambita', country: 'CO'},
          { id: '68307', regionId: 68, name: 'Giron', country: 'CO'},
          { id: '68318', regionId: 68, name: 'Guaca', country: 'CO'},
          { id: '68320', regionId: 68, name: 'Guadalupe', country: 'CO'},
          { id: '68322', regionId: 68, name: 'Guapota', country: 'CO'},
          { id: '68324', regionId: 68, name: 'Guavata', country: 'CO'},
          { id: '68327', regionId: 68, name: 'Guepsa', country: 'CO'},
          { id: '68344', regionId: 68, name: 'Hato', country: 'CO'},
          { id: '68368', regionId: 68, name: 'Jesus Maria', country: 'CO'},
          { id: '68370', regionId: 68, name: 'Jordan', country: 'CO'},
          { id: '68377', regionId: 68, name: 'La Belleza', country: 'CO'},
          { id: '68397', regionId: 68, name: 'La Paz', country: 'CO'},
          { id: '68385', regionId: 68, name: 'Landazuri', country: 'CO'},
          { id: '68406', regionId: 68, name: 'Lebrija', country: 'CO'},
          { id: '68418', regionId: 68, name: 'Los Santos', country: 'CO'},
          { id: '68425', regionId: 68, name: 'Macaravita', country: 'CO'},
          { id: '68432', regionId: 68, name: 'Malaga', country: 'CO'},
          { id: '68444', regionId: 68, name: 'Matanza', country: 'CO'},
          { id: '68464', regionId: 68, name: 'Mogotes', country: 'CO'},
          { id: '68468', regionId: 68, name: 'Molagavita', country: 'CO'},
          { id: '68498', regionId: 68, name: 'Ocamonte', country: 'CO'},
          { id: '68500', regionId: 68, name: 'Oiba', country: 'CO'},
          { id: '68502', regionId: 68, name: 'Onzaga', country: 'CO'},
          { id: '68522', regionId: 68, name: 'Palmar', country: 'CO'},
          { id: '68524', regionId: 68, name: 'Palmas Del Socorro', country: 'CO'},
          { id: '68533', regionId: 68, name: 'Paramo', country: 'CO'},
          { id: '68547', regionId: 68, name: 'Piedecuesta', country: 'CO'},
          { id: '68549', regionId: 68, name: 'Pinchote', country: 'CO'},
          { id: '68572', regionId: 68, name: 'Puente Nacional', country: 'CO'},
          { id: '68573', regionId: 68, name: 'Puerto Parra', country: 'CO'},
          { id: '68575', regionId: 68, name: 'Puerto Wilches', country: 'CO'},
          { id: '68615', regionId: 68, name: 'Rionegro', country: 'CO'},
          { id: '68655', regionId: 68, name: 'Sabana De Torres', country: 'CO'},
          { id: '68669', regionId: 68, name: 'San Andres', country: 'CO'},
          { id: '68673', regionId: 68, name: 'San Benito', country: 'CO'},
          { id: '68679', regionId: 68, name: 'San Gil', country: 'CO'},
          { id: '68682', regionId: 68, name: 'San Joaquin', country: 'CO'},
          { id: '68684', regionId: 68, name: 'San Jose De Miranda', country: 'CO'},
          { id: '68686', regionId: 68, name: 'San Miguel', country: 'CO'},
          { id: '68689', regionId: 68, name: 'San Vicente De Chucuri', country: 'CO'},
          { id: '68705', regionId: 68, name: 'Santa Barbara', country: 'CO'},
          { id: '68720', regionId: 68, name: 'Santa Helena Del Opon', country: 'CO'},
          { id: '68745', regionId: 68, name: 'Simacota', country: 'CO'},
          { id: '68755', regionId: 68, name: 'Socorro', country: 'CO'},
          { id: '68770', regionId: 68, name: 'Suaita', country: 'CO'},
          { id: '68773', regionId: 68, name: 'Sucre', country: 'CO'},
          { id: '68780', regionId: 68, name: 'Surata', country: 'CO'},
          { id: '68820', regionId: 68, name: 'Tona', country: 'CO'},
          { id: '68855', regionId: 68, name: 'Valle San Jose', country: 'CO'},
          { id: '68861', regionId: 68, name: 'Velez', country: 'CO'},
          { id: '68867', regionId: 68, name: 'Vetas', country: 'CO'},
          { id: '68872', regionId: 68, name: 'Villanueva', country: 'CO'},
          { id: '68895', regionId: 68, name: 'Zapatoca', country: 'CO'},
          { id: '70110', regionId: 70, name: 'Buenavista', country: 'CO'},
          { id: '70124', regionId: 70, name: 'Caimito', country: 'CO'},
          { id: '70230', regionId: 70, name: 'Chalan', country: 'CO'},
          { id: '70204', regionId: 70, name: 'Coloso (Ricaurte)', country: 'CO'},
          { id: '70215', regionId: 70, name: 'Corozal', country: 'CO'},
          { id: '70235', regionId: 70, name: 'Galeras (Nueva Granada)', country: 'CO'},
          { id: '70265', regionId: 70, name: 'Guaranda', country: 'CO'},
          { id: '70400', regionId: 70, name: 'La Union', country: 'CO'},
          { id: '70418', regionId: 70, name: 'Los Palmitos', country: 'CO'},
          { id: '70429', regionId: 70, name: 'Majagual', country: 'CO'},
          { id: '70473', regionId: 70, name: 'Morroa', country: 'CO'},
          { id: '70508', regionId: 70, name: 'Ovejas', country: 'CO'},
          { id: '70523', regionId: 70, name: 'Palmito', country: 'CO'},
          { id: '70670', regionId: 70, name: 'Sampues', country: 'CO'},
          { id: '70678', regionId: 70, name: 'San Benito Abad', country: 'CO'},
          { id: '70702', regionId: 70, name: 'San Juan De Betulia', country: 'CO'},
          { id: '70708', regionId: 70, name: 'San Marcos', country: 'CO'},
          { id: '70713', regionId: 70, name: 'San Onofre', country: 'CO'},
          { id: '70717', regionId: 70, name: 'San Pedro', country: 'CO'},
          { id: '70742', regionId: 70, name: 'Since', country: 'CO'},
          { id: '70001', regionId: 70, name: 'Sincelejo', country: 'CO'},
          { id: '70771', regionId: 70, name: 'Sucre', country: 'CO'},
          { id: '70820', regionId: 70, name: 'Tolu', country: 'CO'},
          { id: '70823', regionId: 70, name: 'Toluviejo', country: 'CO'},
          { id: '73024', regionId: 73, name: 'Alpujarra', country: 'CO'},
          { id: '73026', regionId: 73, name: 'Alvarado', country: 'CO'},
          { id: '73030', regionId: 73, name: 'Ambalema', country: 'CO'},
          { id: '73043', regionId: 73, name: 'Anzoategui', country: 'CO'},
          { id: '73055', regionId: 73, name: 'Armero (Guayabal)', country: 'CO'},
          { id: '73067', regionId: 73, name: 'Ataco', country: 'CO'},
          { id: '73124', regionId: 73, name: 'Cajamarca', country: 'CO'},
          { id: '73148', regionId: 73, name: 'Carmen Apicala', country: 'CO'},
          { id: '73152', regionId: 73, name: 'Casabianca', country: 'CO'},
          { id: '73168', regionId: 73, name: 'Chaparral', country: 'CO'},
          { id: '73200', regionId: 73, name: 'Coello', country: 'CO'},
          { id: '73217', regionId: 73, name: 'Coyaima', country: 'CO'},
          { id: '73226', regionId: 73, name: 'Cunday', country: 'CO'},
          { id: '73236', regionId: 73, name: 'Dolores', country: 'CO'},
          { id: '73268', regionId: 73, name: 'Espinal', country: 'CO'},
          { id: '73270', regionId: 73, name: 'Falan', country: 'CO'},
          { id: '73275', regionId: 73, name: 'Flandes', country: 'CO'},
          { id: '73283', regionId: 73, name: 'Fresno', country: 'CO'},
          { id: '73319', regionId: 73, name: 'Guamo', country: 'CO'},
          { id: '73347', regionId: 73, name: 'Herveo', country: 'CO'},
          { id: '73349', regionId: 73, name: 'Honda', country: 'CO'},
          { id: '73001', regionId: 73, name: 'Ibague', country: 'CO'},
          { id: '73352', regionId: 73, name: 'Icononzo', country: 'CO'},
          { id: '73408', regionId: 73, name: 'Lerida', country: 'CO'},
          { id: '73411', regionId: 73, name: 'Libano', country: 'CO'},
          { id: '73443', regionId: 73, name: 'Mariquita', country: 'CO'},
          { id: '73449', regionId: 73, name: 'Melgar', country: 'CO'},
          { id: '73461', regionId: 73, name: 'Murillo', country: 'CO'},
          { id: '73483', regionId: 73, name: 'Natagaima', country: 'CO'},
          { id: '73504', regionId: 73, name: 'Ortega', country: 'CO'},
          { id: '73520', regionId: 73, name: 'Palocabildo', country: 'CO'},
          { id: '73547', regionId: 73, name: 'Piedras', country: 'CO'},
          { id: '73555', regionId: 73, name: 'Planadas', country: 'CO'},
          { id: '73563', regionId: 73, name: 'Prado', country: 'CO'},
          { id: '73585', regionId: 73, name: 'Purificacion', country: 'CO'},
          { id: '73616', regionId: 73, name: 'Rioblanco', country: 'CO'},
          { id: '73622', regionId: 73, name: 'Roncesvalles', country: 'CO'},
          { id: '73624', regionId: 73, name: 'Rovira', country: 'CO'},
          { id: '73671', regionId: 73, name: 'Saldaña', country: 'CO'},
          { id: '73675', regionId: 73, name: 'San Antonio', country: 'CO'},
          { id: '73678', regionId: 73, name: 'San Luis', country: 'CO'},
          { id: '73686', regionId: 73, name: 'Santa Isabel', country: 'CO'},
          { id: '73770', regionId: 73, name: 'Suarez', country: 'CO'},
          { id: '73854', regionId: 73, name: 'Valle De San Juan', country: 'CO'},
          { id: '73861', regionId: 73, name: 'Venadillo', country: 'CO'},
          { id: '73870', regionId: 73, name: 'Villahermosa', country: 'CO'},
          { id: '73873', regionId: 73, name: 'Villarrica', country: 'CO'},
          { id: '76020', regionId: 76, name: 'Alcala', country: 'CO'},
          { id: '76036', regionId: 76, name: 'Andalucia', country: 'CO'},
          { id: '76041', regionId: 76, name: 'Ansermanuevo', country: 'CO'},
          { id: '76054', regionId: 76, name: 'Argelia', country: 'CO'},
          { id: '76100', regionId: 76, name: 'Bolivar', country: 'CO'},
          { id: '76109', regionId: 76, name: 'Buenaventura', country: 'CO'},
          { id: '76111', regionId: 76, name: 'Buga', country: 'CO'},
          { id: '76113', regionId: 76, name: 'Bugalagrande', country: 'CO'},
          { id: '76122', regionId: 76, name: 'Caicedonia', country: 'CO'},
          { id: '76001', regionId: 76, name: 'Cali (Santiago De Cali)', country: 'CO'},
          { id: '76126', regionId: 76, name: 'Calima (Darien)', country: 'CO'},
          { id: '76130', regionId: 76, name: 'Candelaria', country: 'CO'},
          { id: '76147', regionId: 76, name: 'Cartago', country: 'CO'},
          { id: '76233', regionId: 76, name: 'Dagua', country: 'CO'},
          { id: '76243', regionId: 76, name: 'El Aguila', country: 'CO'},
          { id: '76246', regionId: 76, name: 'El Cairo', country: 'CO'},
          { id: '76248', regionId: 76, name: 'El Cerrito', country: 'CO'},
          { id: '76250', regionId: 76, name: 'El Dovio', country: 'CO'},
          { id: '76275', regionId: 76, name: 'Florida', country: 'CO'},
          { id: '76306', regionId: 76, name: 'Ginebra', country: 'CO'},
          { id: '76318', regionId: 76, name: 'Guacari', country: 'CO'},
          { id: '76364', regionId: 76, name: 'Jamundi', country: 'CO'},
          { id: '76377', regionId: 76, name: 'La Cumbre', country: 'CO'},
          { id: '76400', regionId: 76, name: 'La Union', country: 'CO'},
          { id: '76403', regionId: 76, name: 'La Victoria', country: 'CO'},
          { id: '76497', regionId: 76, name: 'Obando', country: 'CO'},
          { id: '76520', regionId: 76, name: 'Palmira', country: 'CO'},
          { id: '76563', regionId: 76, name: 'Pradera', country: 'CO'},
          { id: '76606', regionId: 76, name: 'Restrepo', country: 'CO'},
          { id: '76616', regionId: 76, name: 'Riofrio', country: 'CO'},
          { id: '76622', regionId: 76, name: 'Roldanillo', country: 'CO'},
          { id: '76670', regionId: 76, name: 'San Pedro', country: 'CO'},
          { id: '76736', regionId: 76, name: 'Sevilla', country: 'CO'},
          { id: '76823', regionId: 76, name: 'Toro', country: 'CO'},
          { id: '76828', regionId: 76, name: 'Trujillo', country: 'CO'},
          { id: '76834', regionId: 76, name: 'Tulua', country: 'CO'},
          { id: '76845', regionId: 76, name: 'Ulloa', country: 'CO'},
          { id: '76863', regionId: 76, name: 'Versalles', country: 'CO'},
          { id: '76869', regionId: 76, name: 'Vijes', country: 'CO'},
          { id: '76890', regionId: 76, name: 'Yotoco', country: 'CO'},
          { id: '76892', regionId: 76, name: 'Yumbo', country: 'CO'},
          { id: '76895', regionId: 76, name: 'Zarzal', country: 'CO'},
          { id: '97161', regionId: 97, name: 'Caruru', country: 'CO'},
          { id: '97001', regionId: 97, name: 'Mitu', country: 'CO'},
          { id: '97511', regionId: 97, name: 'Pacoa', country: 'CO'},
          { id: '97777', regionId: 97, name: 'Papunaua (Morichal)', country: 'CO'},
          { id: '97666', regionId: 97, name: 'Taraira', country: 'CO'},
          { id: '97889', regionId: 97, name: 'Yavarate', country: 'CO'},
          { id: '99773', regionId: 99, name: 'Cumaribo', country: 'CO'},
          { id: '99524', regionId: 99, name: 'La Primavera', country: 'CO'},
          { id: '99001', regionId: 99, name: 'Puerto Carreño', country: 'CO'},
          { id: '99760', regionId: 99, name: 'San Jose De Ocune', country: 'CO'},
          { id: '99572', regionId: 99, name: 'Santa Rita', country: 'CO'},
          { id: '99666', regionId: 99, name: 'Santa Rosalia', country: 'CO'},
      )
  }    
  return cityOptions;    
}

export function isTaxSupportedCountry(country) {
  return country == SPAIN || country == COLOMBIA || country == MEXICO;
}

export function isTunnelTaxSupportedCountry(country) {
  return isTunnelPurchaseFlow() && isTaxSupportedCountry(country);
}